/* eslint-disable */
// WARNING: This file is automatically generated. Do not edit.
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSONString: any;
  Upload: any;
};

export type AcceptJob = {
  __typename?: 'AcceptJob';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type Account = AccountNode & {
  __typename?: 'Account';
  accountName?: Maybe<Scalars['String']>;
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  bankAddress?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  beneficiaryAddress?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  swiftCode?: Maybe<Scalars['String']>;
};

export type AccountNode = {
  id: Scalars['ID'];
};

export type AddDriver = {
  __typename?: 'AddDriver';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type AddTrailer = {
  __typename?: 'AddTrailer';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type AddTruck = {
  __typename?: 'AddTruck';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export enum AppEnum {
  Assets = 'ASSETS',
  Lfa = 'LFA',
  Lia = 'LIA',
  Lta = 'LTA'
}

export type AssetList = {
  driverIdNumber: Scalars['String'];
  etaLoadingPoint: Scalars['DateTime'];
  preferredLoadingPoint?: InputMaybe<Scalars['String']>;
  trailerReg?: InputMaybe<Scalars['String']>;
  truckReg: Scalars['String'];
  weight?: InputMaybe<Scalars['String']>;
};

export type AssetPageInfo = {
  __typename?: 'AssetPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type AuthTokens = {
  __typename?: 'AuthTokens';
  AccessToken?: Maybe<Scalars['String']>;
  ExpiresIn?: Maybe<Scalars['Int']>;
  IdToken?: Maybe<Scalars['String']>;
  RefreshToken?: Maybe<Scalars['String']>;
};

export type Banks = BanksDetailsNode & {
  __typename?: 'Banks';
  active?: Maybe<Scalars['Boolean']>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  clearingCode?: Maybe<Scalars['String']>;
  country?: Maybe<CountryEnum>;
  id: Scalars['ID'];
  uuid?: Maybe<Scalars['String']>;
};

export type BanksConnection = {
  __typename?: 'BanksConnection';
  edges: Array<Maybe<BanksEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BanksDetailsNode = {
  id: Scalars['ID'];
};

export type BanksEdge = {
  __typename?: 'BanksEdge';
  cursor: Scalars['String'];
  node?: Maybe<Banks>;
  other?: Maybe<Scalars['String']>;
};

export enum BankSortEnum {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  BankCodeAsc = 'BANK_CODE_ASC',
  BankCodeDesc = 'BANK_CODE_DESC',
  BankNameAsc = 'BANK_NAME_ASC',
  BankNameDesc = 'BANK_NAME_DESC',
  ClearingCodeAsc = 'CLEARING_CODE_ASC',
  ClearingCodeDesc = 'CLEARING_CODE_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UuidAsc = 'UUID_ASC',
  UuidDesc = 'UUID_DESC'
}

export type CancelFuelRequest = {
  __typename?: 'CancelFuelRequest';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelJob = {
  __typename?: 'CancelJob';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type CancelRequestedJobs = {
  __typename?: 'CancelRequestedJobs';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export enum CargoType {
  BaggedAndBulk = 'BAGGED_AND_BULK',
  Container = 'CONTAINER',
  Fmcg = 'FMCG'
}

export type Company = CompanyNode & {
  __typename?: 'Company';
  account?: Maybe<Account>;
  companyEmail: Scalars['String'];
  companyMobile: Scalars['String'];
  companyName: Scalars['String'];
  countryCode: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  directors?: Maybe<DirectorConnection>;
  documents?: Maybe<Document>;
  fleet?: Maybe<Fleet>;
  id: Scalars['ID'];
  isExternal?: Maybe<Scalars['Boolean']>;
  isOnboardedTransporter?: Maybe<Scalars['Boolean']>;
  onboardedtransporterId?: Maybe<Scalars['Int']>;
  onboardingNotified?: Maybe<Scalars['Boolean']>;
  region: Scalars['String'];
  transporterId?: Maybe<Scalars['Int']>;
};


export type CompanyDirectorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges: Array<Maybe<CompanyEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type CompanyDetail = CompanyDetailsNode & {
  __typename?: 'CompanyDetail';
  company?: Maybe<Company>;
  companyId: Scalars['Int'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dateEstablished?: Maybe<Scalars['DateTime']>;
  enterpriseType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberOfDirectors?: Maybe<Scalars['Int']>;
  physicalAddress?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  tradingName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyDetailsNode = {
  id: Scalars['ID'];
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String'];
  node?: Maybe<Company>;
  other?: Maybe<Scalars['String']>;
};

export type CompanyNode = {
  id: Scalars['ID'];
};

export enum CompanySortEnum {
  CompanyEmailAsc = 'COMPANY_EMAIL_ASC',
  CompanyEmailDesc = 'COMPANY_EMAIL_DESC',
  CompanyMobileAsc = 'COMPANY_MOBILE_ASC',
  CompanyMobileDesc = 'COMPANY_MOBILE_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CountryCodeAsc = 'COUNTRY_CODE_ASC',
  CountryCodeDesc = 'COUNTRY_CODE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FleetIdAsc = 'FLEET_ID_ASC',
  FleetIdDesc = 'FLEET_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsExternalAsc = 'IS_EXTERNAL_ASC',
  IsExternalDesc = 'IS_EXTERNAL_DESC',
  IsOnboardedTransporterAsc = 'IS_ONBOARDED_TRANSPORTER_ASC',
  IsOnboardedTransporterDesc = 'IS_ONBOARDED_TRANSPORTER_DESC',
  OnboardedTransporterEntIdAsc = 'ONBOARDED_TRANSPORTER_ENT_ID_ASC',
  OnboardedTransporterEntIdDesc = 'ONBOARDED_TRANSPORTER_ENT_ID_DESC',
  OnboardingNotifiedAsc = 'ONBOARDING_NOTIFIED_ASC',
  OnboardingNotifiedDesc = 'ONBOARDING_NOTIFIED_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  TransporterEntIdAsc = 'TRANSPORTER_ENT_ID_ASC',
  TransporterEntIdDesc = 'TRANSPORTER_ENT_ID_DESC'
}

export type ConfirmAssetList = {
  driverIdNumber?: InputMaybe<Scalars['String']>;
  etaLoadingPoint?: InputMaybe<Scalars['DateTime']>;
  jobRequestId: Scalars['Int'];
  preferredLoadingPoint?: InputMaybe<Scalars['String']>;
  trailerReg?: InputMaybe<Scalars['String']>;
  trailerTypeId?: InputMaybe<Scalars['Int']>;
  truckReg?: InputMaybe<Scalars['String']>;
};

export type ConfirmJob = {
  __typename?: 'ConfirmJob';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type Contact = ContactNode & {
  __typename?: 'Contact';
  adminContactName?: Maybe<Scalars['String']>;
  adminEmail?: Maybe<Scalars['String']>;
  adminTelNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mobileNumber?: Maybe<Scalars['String']>;
  operationsContactName?: Maybe<Scalars['String']>;
  operationsEmail?: Maybe<Scalars['String']>;
  operationsTelNumber?: Maybe<Scalars['String']>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  edges: Array<Maybe<ContactEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String'];
  node?: Maybe<Contact>;
  other?: Maybe<Scalars['String']>;
};

export type ContactNode = {
  id: Scalars['ID'];
};

export enum ContactSortEnum {
  AdminContactNameAsc = 'ADMIN_CONTACT_NAME_ASC',
  AdminContactNameDesc = 'ADMIN_CONTACT_NAME_DESC',
  AdminEmailAsc = 'ADMIN_EMAIL_ASC',
  AdminEmailDesc = 'ADMIN_EMAIL_DESC',
  AdminTelNumberAsc = 'ADMIN_TEL_NUMBER_ASC',
  AdminTelNumberDesc = 'ADMIN_TEL_NUMBER_DESC',
  CompanyIdAsc = 'COMPANY_ID_ASC',
  CompanyIdDesc = 'COMPANY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MobileNumberAsc = 'MOBILE_NUMBER_ASC',
  MobileNumberDesc = 'MOBILE_NUMBER_DESC',
  OperationsContactNameAsc = 'OPERATIONS_CONTACT_NAME_ASC',
  OperationsContactNameDesc = 'OPERATIONS_CONTACT_NAME_DESC',
  OperationsEmailAsc = 'OPERATIONS_EMAIL_ASC',
  OperationsEmailDesc = 'OPERATIONS_EMAIL_DESC',
  OperationsTelNumberAsc = 'OPERATIONS_TEL_NUMBER_ASC',
  OperationsTelNumberDesc = 'OPERATIONS_TEL_NUMBER_DESC'
}

export enum CountryEnum {
  Ke = 'KE',
  Ng = 'NG',
  Ug = 'UG'
}

export type CreateCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  countryCode: Scalars['String'];
  countryIsoCode: Scalars['String'];
  countryRegion: Scalars['String'];
};

export type CreateCountryPayload = {
  __typename?: 'CreateCountryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateErcFuelPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  period: Scalars['Date'];
  price: Scalars['Float'];
};

export type CreateErcFuelPricePayload = {
  __typename?: 'CreateERCFuelPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ErcFuelPrice>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateFuelRequestInput = {
  fsCountry?: InputMaybe<Scalars['String']>;
  fuelreqtra?: InputMaybe<Scalars['String']>;
  fuelRequestAmount?: InputMaybe<Scalars['Int']>;
  fuelStationCode?: InputMaybe<Scalars['String']>;
  fuelStationId?: InputMaybe<Scalars['Int']>;
  fuelType?: InputMaybe<Scalars['String']>;
  lroId?: InputMaybe<Scalars['Int']>;
  transporterId?: InputMaybe<Scalars['Int']>;
  truckReg?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CreateFuelRequestPayload = {
  __typename?: 'CreateFuelRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fuelRequest?: Maybe<FuelRequest>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTracking = {
  __typename?: 'CreateTracking';
  message?: Maybe<Scalars['String']>;
  rowCount?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type CreateUserAttributeInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateUserAttributePayload = {
  __typename?: 'CreateUserAttributePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  userAttribute?: Maybe<UserAttribute>;
};

export type DeleteAccountInput = {
  accountNumber: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteAccountPayload = {
  __typename?: 'DeleteAccountPayload';
  account?: Maybe<Account>;
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCompanyDetailsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteCompanyDetailsPayload = {
  __typename?: 'DeleteCompanyDetailsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  companyDetail?: Maybe<CompanyDetail>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type DeleteCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteCompanyPayload = {
  __typename?: 'DeleteCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type DeleteContactInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteCountryPayload = {
  __typename?: 'DeleteCountryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteDocumentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteErcFuelPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteErcFuelPricePayload = {
  __typename?: 'DeleteERCFuelPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ErcFuelPrice>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteFleetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteFleetPayload = {
  __typename?: 'DeleteFleetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fleet?: Maybe<Fleet>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteFuelRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteFuelRequestPayload = {
  __typename?: 'DeleteFuelRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fuelRequest?: Maybe<FuelRequest>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteInsuranceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteInsurancePayload = {
  __typename?: 'DeleteInsurancePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insurance?: Maybe<Insurance>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteProfilePayload = {
  __typename?: 'DeleteProfilePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<Profile>;
};

export type DeleteUserAttributeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteUserAttributePayload = {
  __typename?: 'DeleteUserAttributePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  userAttribute?: Maybe<UserAttribute>;
};

export type Director = DirectorNode & {
  __typename?: 'Director';
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directorName?: Maybe<Scalars['String']>;
  directorNumber?: Maybe<Scalars['String']>;
  directorResidentialAddress?: Maybe<Scalars['String']>;
  directorTelNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DirectorConnection = {
  __typename?: 'DirectorConnection';
  edges: Array<Maybe<DirectorEdge>>;
  pageInfo: PageInfo;
};

export type DirectorDetailsInput = {
  directorName?: InputMaybe<Scalars['String']>;
  directorNumber?: InputMaybe<Scalars['String']>;
  directorResidentialAddress?: InputMaybe<Scalars['String']>;
  directorTelNumber?: InputMaybe<Scalars['String']>;
};

export type DirectorEdge = {
  __typename?: 'DirectorEdge';
  cursor: Scalars['String'];
  node?: Maybe<Director>;
};

export type DirectorNode = {
  id: Scalars['ID'];
};

export type Document = DocumentNode & {
  __typename?: 'Document';
  bankLetter?: Maybe<Scalars['String']>;
  beeCertificate?: Maybe<Scalars['String']>;
  carrierResolution?: Maybe<Scalars['String']>;
  carriersLiability?: Maybe<Scalars['String']>;
  carriersLiabilityExpiry?: Maybe<Scalars['DateTime']>;
  certificateOfIncorporation?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  companyLetterhead?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  directorIdentification?: Maybe<Scalars['String']>;
  directorKraPin?: Maybe<Scalars['String']>;
  directorsIds?: Maybe<Scalars['String']>;
  gitCoverConfirmation?: Maybe<Scalars['String']>;
  gitCoverExpiry?: Maybe<Scalars['DateTime']>;
  goodsInTransitCertificate?: Maybe<Scalars['String']>;
  hasQualityManagementCert?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insurancePolicies?: Maybe<Scalars['String']>;
  isVatRegistered?: Maybe<Scalars['Boolean']>;
  kraPin?: Maybe<Scalars['String']>;
  kraTcc?: Maybe<Scalars['String']>;
  letterOfGoodStanding?: Maybe<Scalars['String']>;
  proofOfDirectorship?: Maybe<Scalars['String']>;
  qualityManagementCertificate?: Maybe<Scalars['String']>;
  registrationCertificate?: Maybe<Scalars['String']>;
  signedLoriContract?: Maybe<Scalars['String']>;
  taxClearanceCertificate?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatCertificate?: Maybe<Scalars['String']>;
  vatRegistrationNumber?: Maybe<Scalars['String']>;
  vehicleRegistrationDocuments?: Maybe<Scalars['String']>;
};

export type DocumentNode = {
  id: Scalars['ID'];
};

export type DocumentProps = {
  __typename?: 'DocumentProps';
  document?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Driver = {
  __typename?: 'Driver';
  active?: Maybe<Scalars['Boolean']>;
  countryCode?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['Int']>;
  driverIdNumber?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  driverPhoneNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  transporterId?: Maybe<Scalars['Int']>;
};

export type DriverEdge = {
  __typename?: 'DriverEdge';
  cursor: Scalars['String'];
  node?: Maybe<Driver>;
};

export type DriverInput = {
  driverIdNumber: Scalars['String'];
  driverName: Scalars['String'];
  driverPhone: Scalars['String'];
};

export type Drivers = {
  __typename?: 'Drivers';
  edges: Array<Maybe<DriverEdge>>;
  pageInfo: AssetPageInfo;
};

export type ErcFuelPrice = ErcFuelPriceNode & {
  __typename?: 'ERCFuelPrice';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  month: Scalars['Int'];
  period: Scalars['String'];
  price: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  year: Scalars['Int'];
};

export type ErcFuelPriceConnection = {
  __typename?: 'ERCFuelPriceConnection';
  edges: Array<Maybe<ErcFuelPriceEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type ErcFuelPriceEdge = {
  __typename?: 'ERCFuelPriceEdge';
  cursor: Scalars['String'];
  node?: Maybe<ErcFuelPrice>;
  other?: Maybe<Scalars['String']>;
};

export type ErcFuelPriceNode = {
  id: Scalars['ID'];
};

export enum ErcFuelPriceSortEnum {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MonthAsc = 'MONTH_ASC',
  MonthDesc = 'MONTH_DESC',
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

export type Fleet = FleetNode & {
  __typename?: 'Fleet';
  fleetType: Scalars['String'];
  id: Scalars['ID'];
};

export type FleetNode = {
  id: Scalars['ID'];
};

export type FuelingData = FuelingDataNode & {
  __typename?: 'FuelingData';
  amountFuelled?: Maybe<Scalars['Float']>;
  approvalState?: Maybe<Scalars['String']>;
  cityLevy?: Maybe<Scalars['Float']>;
  deplorifs?: Maybe<Scalars['DateTime']>;
  fsCity?: Maybe<Scalars['String']>;
  fsCountry?: Maybe<Scalars['String']>;
  fsInvoice?: Maybe<Scalars['String']>;
  fuelDataValidated?: Maybe<Scalars['DateTime']>;
  fuelLpo?: Maybe<Scalars['String']>;
  fuelPriceDiscount?: Maybe<Scalars['Float']>;
  fuelreqsent?: Maybe<Scalars['DateTime']>;
  fuelreqtra?: Maybe<Scalars['DateTime']>;
  fuelRequestAmount?: Maybe<Scalars['Float']>;
  fuelStation?: Maybe<Scalars['String']>;
  fuelStationPrice?: Maybe<Scalars['Float']>;
  fuelType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lroId?: Maybe<Scalars['Int']>;
  moveId?: Maybe<Scalars['Int']>;
  stageNotes?: Maybe<Scalars['String']>;
  transporterId?: Maybe<Scalars['Int']>;
  transporterInvoice?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
  vatableExclusive?: Maybe<Scalars['Float']>;
};

export type FuelingDataConnection = {
  __typename?: 'FuelingDataConnection';
  edges: Array<Maybe<FuelingDataEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FuelingDataEdge = {
  __typename?: 'FuelingDataEdge';
  cursor: Scalars['String'];
  node?: Maybe<FuelingData>;
  other?: Maybe<Scalars['String']>;
};

export type FuelingDataNode = {
  id: Scalars['ID'];
};

export type FuelLimits = {
  __typename?: 'FuelLimits';
  maxFuelAmount?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  waFuelOptions?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type FuelRequest = FuelRequestNode & {
  __typename?: 'FuelRequest';
  amountFuelled?: Maybe<Scalars['Float']>;
  approvalState?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  destination: Scalars['String'];
  fuelAmount: Scalars['Float'];
  fuelreqtra?: Maybe<Scalars['String']>;
  fuelRequestAmount?: Maybe<Scalars['Int']>;
  fuelStation?: Maybe<Scalars['String']>;
  fuelStationCode: Scalars['String'];
  fuelStationId?: Maybe<Scalars['Int']>;
  fuelType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCancelled?: Maybe<Scalars['Boolean']>;
  lroId: Scalars['String'];
  moveId: Scalars['Int'];
  origin: Scalars['String'];
  requestDate?: Maybe<Scalars['DateTime']>;
  transporterId: Scalars['Int'];
  truckReg: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FuelRequestConnection = {
  __typename?: 'FuelRequestConnection';
  edges: Array<Maybe<FuelRequestEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type FuelRequestEdge = {
  __typename?: 'FuelRequestEdge';
  cursor: Scalars['String'];
  node?: Maybe<FuelRequest>;
  other?: Maybe<Scalars['String']>;
};

export type FuelRequestNode = {
  id: Scalars['ID'];
};

export type FuelStation = FuelStationNode & {
  __typename?: 'FuelStation';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  geoId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Int']>;
  ownerName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type FuelStationConnection = {
  __typename?: 'FuelStationConnection';
  edges: Array<Maybe<FuelStationEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type FuelStationEdge = {
  __typename?: 'FuelStationEdge';
  cursor: Scalars['String'];
  node?: Maybe<FuelStation>;
  other?: Maybe<Scalars['String']>;
};

export type FuelStationNode = {
  id: Scalars['ID'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type GeoLocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type ImportDriver = {
  __typename?: 'ImportDriver';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['JSONString']>;
  status?: Maybe<Scalars['Int']>;
};

export type ImportTrailer = {
  __typename?: 'ImportTrailer';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['JSONString']>;
  status?: Maybe<Scalars['Int']>;
};

export type ImportTruck = {
  __typename?: 'ImportTruck';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['JSONString']>;
  status?: Maybe<Scalars['Int']>;
};

export type Insurance = InsuranceNode & {
  __typename?: 'Insurance';
  broker?: Maybe<Scalars['String']>;
  brokerContactName?: Maybe<Scalars['String']>;
  brokerEmail?: Maybe<Scalars['String']>;
  brokerTelNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  gitCoverPerLoad?: Maybe<Scalars['String']>;
  hasComprehensiveGitCover?: Maybe<Scalars['Boolean']>;
  hasPublicLiabilityInsurance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insuranceCompany?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
};

export type InsuranceConnection = {
  __typename?: 'InsuranceConnection';
  edges: Array<Maybe<InsuranceEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type InsuranceEdge = {
  __typename?: 'InsuranceEdge';
  cursor: Scalars['String'];
  node?: Maybe<Insurance>;
  other?: Maybe<Scalars['String']>;
};

export type InsuranceNode = {
  id: Scalars['ID'];
};

export enum InsuranceSortEnum {
  BrokerAsc = 'BROKER_ASC',
  BrokerContactNameAsc = 'BROKER_CONTACT_NAME_ASC',
  BrokerContactNameDesc = 'BROKER_CONTACT_NAME_DESC',
  BrokerDesc = 'BROKER_DESC',
  BrokerEmailAsc = 'BROKER_EMAIL_ASC',
  BrokerEmailDesc = 'BROKER_EMAIL_DESC',
  BrokerTelNumberAsc = 'BROKER_TEL_NUMBER_ASC',
  BrokerTelNumberDesc = 'BROKER_TEL_NUMBER_DESC',
  CompanyIdAsc = 'COMPANY_ID_ASC',
  CompanyIdDesc = 'COMPANY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GitCoverPerLoadAsc = 'GIT_COVER_PER_LOAD_ASC',
  GitCoverPerLoadDesc = 'GIT_COVER_PER_LOAD_DESC',
  HasComprehensiveGitCoverAsc = 'HAS_COMPREHENSIVE_GIT_COVER_ASC',
  HasComprehensiveGitCoverDesc = 'HAS_COMPREHENSIVE_GIT_COVER_DESC',
  HasPublicLiabilityInsuranceAsc = 'HAS_PUBLIC_LIABILITY_INSURANCE_ASC',
  HasPublicLiabilityInsuranceDesc = 'HAS_PUBLIC_LIABILITY_INSURANCE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InsuranceCompanyAsc = 'INSURANCE_COMPANY_ASC',
  InsuranceCompanyDesc = 'INSURANCE_COMPANY_DESC',
  PolicyNumberAsc = 'POLICY_NUMBER_ASC',
  PolicyNumberDesc = 'POLICY_NUMBER_DESC'
}

export enum JobCategory {
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Fueling = 'FUELING',
  Matched = 'MATCHED',
  New = 'NEW',
  OnJourney = 'ON_JOURNEY',
  Submitted = 'SUBMITTED'
}

export type JobModel = JobModelNode & {
  __typename?: 'JobModel';
  address?: Maybe<Scalars['String']>;
  allocationFailureReason?: Maybe<Scalars['String']>;
  allocationUpdated?: Maybe<Scalars['Boolean']>;
  assetsLastUpdated?: Maybe<Scalars['DateTime']>;
  bidPrice?: Maybe<Scalars['Float']>;
  cargoType?: Maybe<Scalars['String']>;
  cargoTypeId?: Maybe<Scalars['Int']>;
  commodity?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  consignee?: Maybe<Scalars['String']>;
  consigneeId?: Maybe<Scalars['Int']>;
  consignmentMetricTons?: Maybe<Scalars['String']>;
  containerGrossWeight?: Maybe<Scalars['Int']>;
  containerNumber?: Maybe<Scalars['String']>;
  containerNumber2?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  currentStage?: Maybe<Scalars['String']>;
  dambags?: Maybe<Scalars['String']>;
  deadlineToLift?: Maybe<Scalars['String']>;
  destination?: Maybe<Scalars['String']>;
  destinationCity?: Maybe<Scalars['String']>;
  destinationCountry?: Maybe<Scalars['String']>;
  destinationGeoCode?: Maybe<Scalars['String']>;
  driverId?: Maybe<Scalars['String']>;
  driverIdNumber?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  emptyReturnDestination?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAllocated?: Maybe<Scalars['Boolean']>;
  isBid?: Maybe<Scalars['Boolean']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  isCreatedOnLia?: Maybe<Scalars['Boolean']>;
  isUserCancellation?: Maybe<Scalars['Boolean']>;
  jobRequestId?: Maybe<Scalars['Int']>;
  loriRate?: Maybe<Scalars['Float']>;
  lowerBidMargin?: Maybe<Scalars['Float']>;
  lroId: Scalars['String'];
  marketRate?: Maybe<Scalars['Float']>;
  match?: Maybe<Scalars['Boolean']>;
  matchingFailureReason?: Maybe<Scalars['String']>;
  matchUpdated?: Maybe<Scalars['Boolean']>;
  maximumFuelAmount?: Maybe<Scalars['Float']>;
  moveId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
  originCity?: Maybe<Scalars['String']>;
  originCountry?: Maybe<Scalars['String']>;
  originGeocode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  readyToLoad?: Maybe<Scalars['DateTime']>;
  sealNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  totalLiters?: Maybe<Scalars['Float']>;
  trailerNumber?: Maybe<Scalars['String']>;
  trailerType?: Maybe<Scalars['String']>;
  transportAccountManager?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  transporterCurrency?: Maybe<Scalars['String']>;
  transporterId?: Maybe<Scalars['Int']>;
  transporterPaymentTerms?: Maybe<Scalars['String']>;
  transporterRate?: Maybe<Scalars['Float']>;
  transporterRateType?: Maybe<Scalars['String']>;
  truckCountLastUpdated?: Maybe<Scalars['DateTime']>;
  truckList?: Maybe<Scalars['JSONString']>;
  truckReg?: Maybe<Scalars['String']>;
  trucksMatched?: Maybe<Scalars['Int']>;
  trucksNeeded?: Maybe<Scalars['Int']>;
  truckType?: Maybe<Scalars['String']>;
  unmatchingReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  upperBidMargin?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['String']>;
};

export type JobModelConnection = {
  __typename?: 'JobModelConnection';
  edges: Array<Maybe<JobModelEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type JobModelEdge = {
  __typename?: 'JobModelEdge';
  cursor: Scalars['String'];
  node?: Maybe<JobModel>;
  other?: Maybe<Scalars['String']>;
};

export type JobModelNode = {
  id: Scalars['ID'];
};

export enum JobModelSortEnum {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  AllocationFailureReasonAsc = 'ALLOCATION_FAILURE_REASON_ASC',
  AllocationFailureReasonDesc = 'ALLOCATION_FAILURE_REASON_DESC',
  AllocationUpdatedAsc = 'ALLOCATION_UPDATED_ASC',
  AllocationUpdatedDesc = 'ALLOCATION_UPDATED_DESC',
  AssetsLastUpdatedAsc = 'ASSETS_LAST_UPDATED_ASC',
  AssetsLastUpdatedDesc = 'ASSETS_LAST_UPDATED_DESC',
  BidPriceAsc = 'BID_PRICE_ASC',
  BidPriceDesc = 'BID_PRICE_DESC',
  CargoTypeAsc = 'CARGO_TYPE_ASC',
  CargoTypeDesc = 'CARGO_TYPE_DESC',
  CargoTypeIdAsc = 'CARGO_TYPE_ID_ASC',
  CargoTypeIdDesc = 'CARGO_TYPE_ID_DESC',
  CommodityAsc = 'COMMODITY_ASC',
  CommodityDesc = 'COMMODITY_DESC',
  CompletedAsc = 'COMPLETED_ASC',
  CompletedDesc = 'COMPLETED_DESC',
  ConsigneeAsc = 'CONSIGNEE_ASC',
  ConsigneeDesc = 'CONSIGNEE_DESC',
  ConsigneeIdAsc = 'CONSIGNEE_ID_ASC',
  ConsigneeIdDesc = 'CONSIGNEE_ID_DESC',
  ConsignmentMetricTonsAsc = 'CONSIGNMENT_METRIC_TONS_ASC',
  ConsignmentMetricTonsDesc = 'CONSIGNMENT_METRIC_TONS_DESC',
  ContainerGrossWeightAsc = 'CONTAINER_GROSS_WEIGHT_ASC',
  ContainerGrossWeightDesc = 'CONTAINER_GROSS_WEIGHT_DESC',
  ContainerNumber_2Asc = 'CONTAINER_NUMBER_2_ASC',
  ContainerNumber_2Desc = 'CONTAINER_NUMBER_2_DESC',
  ContainerNumberAsc = 'CONTAINER_NUMBER_ASC',
  ContainerNumberDesc = 'CONTAINER_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrencyAsc = 'CURRENCY_ASC',
  CurrencyDesc = 'CURRENCY_DESC',
  CurrentStageAsc = 'CURRENT_STAGE_ASC',
  CurrentStageDesc = 'CURRENT_STAGE_DESC',
  DambagsAsc = 'DAMBAGS_ASC',
  DambagsDesc = 'DAMBAGS_DESC',
  DeadlineToLiftAsc = 'DEADLINE_TO_LIFT_ASC',
  DeadlineToLiftDesc = 'DEADLINE_TO_LIFT_DESC',
  DestinationAsc = 'DESTINATION_ASC',
  DestinationCityAsc = 'DESTINATION_CITY_ASC',
  DestinationCityDesc = 'DESTINATION_CITY_DESC',
  DestinationCountryAsc = 'DESTINATION_COUNTRY_ASC',
  DestinationCountryDesc = 'DESTINATION_COUNTRY_DESC',
  DestinationDesc = 'DESTINATION_DESC',
  DestinationGeoCodeAsc = 'DESTINATION_GEO_CODE_ASC',
  DestinationGeoCodeDesc = 'DESTINATION_GEO_CODE_DESC',
  DriverIdAsc = 'DRIVER_ID_ASC',
  DriverIdDesc = 'DRIVER_ID_DESC',
  DriverIdNumberAsc = 'DRIVER_ID_NUMBER_ASC',
  DriverIdNumberDesc = 'DRIVER_ID_NUMBER_DESC',
  DriverNameAsc = 'DRIVER_NAME_ASC',
  DriverNameDesc = 'DRIVER_NAME_DESC',
  EmptyReturnDestinationAsc = 'EMPTY_RETURN_DESTINATION_ASC',
  EmptyReturnDestinationDesc = 'EMPTY_RETURN_DESTINATION_DESC',
  EtaLoadingPointAsc = 'ETA_LOADING_POINT_ASC',
  EtaLoadingPointDesc = 'ETA_LOADING_POINT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAllocatedAsc = 'IS_ALLOCATED_ASC',
  IsAllocatedDesc = 'IS_ALLOCATED_DESC',
  IsBidAsc = 'IS_BID_ASC',
  IsBidDesc = 'IS_BID_DESC',
  IsCancelledAsc = 'IS_CANCELLED_ASC',
  IsCancelledDesc = 'IS_CANCELLED_DESC',
  IsConfirmedAsc = 'IS_CONFIRMED_ASC',
  IsConfirmedDesc = 'IS_CONFIRMED_DESC',
  IsCreatedOnLiaAsc = 'IS_CREATED_ON_LIA_ASC',
  IsCreatedOnLiaDesc = 'IS_CREATED_ON_LIA_DESC',
  IsUserCancellationAsc = 'IS_USER_CANCELLATION_ASC',
  IsUserCancellationDesc = 'IS_USER_CANCELLATION_DESC',
  LoriRateAsc = 'LORI_RATE_ASC',
  LoriRateDesc = 'LORI_RATE_DESC',
  LowerBidMarginAsc = 'LOWER_BID_MARGIN_ASC',
  LowerBidMarginDesc = 'LOWER_BID_MARGIN_DESC',
  LroIdAsc = 'LRO_ID_ASC',
  LroIdDesc = 'LRO_ID_DESC',
  MarketRateAsc = 'MARKET_RATE_ASC',
  MarketRateDesc = 'MARKET_RATE_DESC',
  MatchAsc = 'MATCH_ASC',
  MatchDesc = 'MATCH_DESC',
  MatchUpdatedAsc = 'MATCH_UPDATED_ASC',
  MatchUpdatedDesc = 'MATCH_UPDATED_DESC',
  MatchingFailureReasonAsc = 'MATCHING_FAILURE_REASON_ASC',
  MatchingFailureReasonDesc = 'MATCHING_FAILURE_REASON_DESC',
  MaximumFuelAmountAsc = 'MAXIMUM_FUEL_AMOUNT_ASC',
  MaximumFuelAmountDesc = 'MAXIMUM_FUEL_AMOUNT_DESC',
  MoveIdAsc = 'MOVE_ID_ASC',
  MoveIdDesc = 'MOVE_ID_DESC',
  OriginAsc = 'ORIGIN_ASC',
  OriginCityAsc = 'ORIGIN_CITY_ASC',
  OriginCityDesc = 'ORIGIN_CITY_DESC',
  OriginCountryAsc = 'ORIGIN_COUNTRY_ASC',
  OriginCountryDesc = 'ORIGIN_COUNTRY_DESC',
  OriginDesc = 'ORIGIN_DESC',
  OriginGeocodeAsc = 'ORIGIN_GEOCODE_ASC',
  OriginGeocodeDesc = 'ORIGIN_GEOCODE_DESC',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  ReadyToLoadAsc = 'READY_TO_LOAD_ASC',
  ReadyToLoadDesc = 'READY_TO_LOAD_DESC',
  SealNumberAsc = 'SEAL_NUMBER_ASC',
  SealNumberDesc = 'SEAL_NUMBER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SupplyIdAsc = 'SUPPLY_ID_ASC',
  SupplyIdDesc = 'SUPPLY_ID_DESC',
  TotalLitersAsc = 'TOTAL_LITERS_ASC',
  TotalLitersDesc = 'TOTAL_LITERS_DESC',
  TrailerNumberAsc = 'TRAILER_NUMBER_ASC',
  TrailerNumberDesc = 'TRAILER_NUMBER_DESC',
  TrailerTypeAsc = 'TRAILER_TYPE_ASC',
  TrailerTypeDesc = 'TRAILER_TYPE_DESC',
  TransportAccountManagerAsc = 'TRANSPORT_ACCOUNT_MANAGER_ASC',
  TransportAccountManagerDesc = 'TRANSPORT_ACCOUNT_MANAGER_DESC',
  TransporterAsc = 'TRANSPORTER_ASC',
  TransporterCurrencyAsc = 'TRANSPORTER_CURRENCY_ASC',
  TransporterCurrencyDesc = 'TRANSPORTER_CURRENCY_DESC',
  TransporterDesc = 'TRANSPORTER_DESC',
  TransporterEntIdAsc = 'TRANSPORTER_ENT_ID_ASC',
  TransporterEntIdDesc = 'TRANSPORTER_ENT_ID_DESC',
  TransporterPaymentTermsAsc = 'TRANSPORTER_PAYMENT_TERMS_ASC',
  TransporterPaymentTermsDesc = 'TRANSPORTER_PAYMENT_TERMS_DESC',
  TransporterRateAsc = 'TRANSPORTER_RATE_ASC',
  TransporterRateDesc = 'TRANSPORTER_RATE_DESC',
  TransporterRateTypeAsc = 'TRANSPORTER_RATE_TYPE_ASC',
  TransporterRateTypeDesc = 'TRANSPORTER_RATE_TYPE_DESC',
  TruckCountLastUpdatedAsc = 'TRUCK_COUNT_LAST_UPDATED_ASC',
  TruckCountLastUpdatedDesc = 'TRUCK_COUNT_LAST_UPDATED_DESC',
  TruckListAsc = 'TRUCK_LIST_ASC',
  TruckListDesc = 'TRUCK_LIST_DESC',
  TruckRegAsc = 'TRUCK_REG_ASC',
  TruckRegDesc = 'TRUCK_REG_DESC',
  TruckTypeAsc = 'TRUCK_TYPE_ASC',
  TruckTypeDesc = 'TRUCK_TYPE_DESC',
  TrucksMatchedAsc = 'TRUCKS_MATCHED_ASC',
  TrucksMatchedDesc = 'TRUCKS_MATCHED_DESC',
  TrucksNeededAsc = 'TRUCKS_NEEDED_ASC',
  TrucksNeededDesc = 'TRUCKS_NEEDED_DESC',
  UnmatchingReasonAsc = 'UNMATCHING_REASON_ASC',
  UnmatchingReasonDesc = 'UNMATCHING_REASON_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpperBidMarginAsc = 'UPPER_BID_MARGIN_ASC',
  UpperBidMarginDesc = 'UPPER_BID_MARGIN_DESC',
  WeightAsc = 'WEIGHT_ASC',
  WeightDesc = 'WEIGHT_DESC'
}

export type MatchInput = {
  failed?: InputMaybe<Array<InputMaybe<Scalars['JSONString']>>>;
  jobRequestId: Scalars['Int'];
  lroId?: InputMaybe<Scalars['String']>;
  matched?: InputMaybe<Array<InputMaybe<Scalars['JSONString']>>>;
  transporter?: InputMaybe<Scalars['String']>;
  transporterId?: InputMaybe<Scalars['Int']>;
};

export type Move = MoveNode & {
  __typename?: 'Move';
  address?: Maybe<Scalars['String']>;
  cargoType?: Maybe<Scalars['String']>;
  cargoTypeId?: Maybe<Scalars['Int']>;
  commodity?: Maybe<Scalars['String']>;
  consignee?: Maybe<Scalars['String']>;
  consigneeId?: Maybe<Scalars['Int']>;
  consignmentMetricTons?: Maybe<Scalars['String']>;
  containerGrossWeight?: Maybe<Scalars['Float']>;
  containerNumber?: Maybe<Scalars['String']>;
  containerNumber2?: Maybe<Scalars['String']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  currentStage?: Maybe<Scalars['String']>;
  dambags?: Maybe<Scalars['String']>;
  deadlineToLift?: Maybe<Scalars['Date']>;
  destination?: Maybe<Scalars['String']>;
  destinationCity?: Maybe<Scalars['String']>;
  destinationCountry?: Maybe<Scalars['String']>;
  destinationGeoCode?: Maybe<Scalars['String']>;
  driverNames?: Maybe<Scalars['String']>;
  emptyReturnDestination?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastKnownLocation?: Maybe<Scalars['String']>;
  lowerBidMargin?: Maybe<Scalars['Float']>;
  lroId?: Maybe<Scalars['String']>;
  marketRate?: Maybe<Scalars['Float']>;
  match?: Maybe<Scalars['Boolean']>;
  matchUpdated?: Maybe<Scalars['Boolean']>;
  maximumFuelAmount?: Maybe<Scalars['Float']>;
  moveId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
  originCity?: Maybe<Scalars['String']>;
  originCountry?: Maybe<Scalars['String']>;
  originGeocode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  readyToLoad?: Maybe<Scalars['DateTime']>;
  region?: Maybe<Scalars['String']>;
  sealNumber?: Maybe<Scalars['String']>;
  totalLiters?: Maybe<Scalars['Float']>;
  trailerNumber?: Maybe<Scalars['String']>;
  trailerType?: Maybe<Scalars['String']>;
  transportAccountManager?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  transporterCurrency?: Maybe<Scalars['String']>;
  transporterPaymentTerms?: Maybe<Scalars['String']>;
  transporterRate?: Maybe<Scalars['Float']>;
  transporterRateType?: Maybe<Scalars['String']>;
  transportType?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
  trucksMatched?: Maybe<Scalars['Float']>;
  trucksNeeded?: Maybe<Scalars['Int']>;
  trucksShortlisted?: Maybe<Scalars['String']>;
  truckType?: Maybe<Scalars['String']>;
  upperBidMargin?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['String']>;
};

export type MoveNode = {
  id: Scalars['ID'];
};

export type MovesConnection = {
  __typename?: 'MovesConnection';
  edges: Array<Maybe<MovesEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MovesEdge = {
  __typename?: 'MovesEdge';
  cursor: Scalars['String'];
  node?: Maybe<Move>;
  other?: Maybe<Scalars['String']>;
};

export enum MoveType {
  Export = 'EXPORT',
  Local = 'LOCAL',
  Transit = 'TRANSIT'
}

export type Node = {
  id: Scalars['ID'];
};

export type Operation = {
  __typename?: 'Operation';
  moveId?: Maybe<Scalars['Int']>;
  truck?: Maybe<OperationTruck>;
  truckReg?: Maybe<Scalars['String']>;
};

export type OperationTruck = {
  __typename?: 'OperationTruck';
  id?: Maybe<Scalars['Int']>;
};

export type Order = OrderNode & {
  __typename?: 'Order';
  assetJson?: Maybe<Scalars['String']>;
  bidPrice?: Maybe<Scalars['Float']>;
  cargoType?: Maybe<Scalars['String']>;
  commodity?: Maybe<Scalars['String']>;
  consignmentMetricTons?: Maybe<Scalars['Float']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deadlineToLift?: Maybe<Scalars['Date']>;
  destination?: Maybe<Scalars['String']>;
  driverIdNumber?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isBid?: Maybe<Scalars['Boolean']>;
  lastKnownLocation?: Maybe<Scalars['String']>;
  lowerBidMargin?: Maybe<Scalars['Float']>;
  lroId?: Maybe<Scalars['String']>;
  marketRate?: Maybe<Scalars['Float']>;
  maximumFuelAmount?: Maybe<Scalars['Float']>;
  moveId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
  packagingType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  readyToLoad?: Maybe<Scalars['DateTime']>;
  totalLiters?: Maybe<Scalars['Float']>;
  totalRequested?: Maybe<Scalars['Int']>;
  trailerNumber?: Maybe<Scalars['String']>;
  trailerType?: Maybe<Scalars['String']>;
  trailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  transporterPaymentTerms?: Maybe<Scalars['String']>;
  transporterRateType?: Maybe<Scalars['String']>;
  truckList?: Maybe<Array<Maybe<TruckList>>>;
  truckReg?: Maybe<Scalars['String']>;
  trucksMatched?: Maybe<Scalars['Int']>;
  trucksNeeded?: Maybe<Scalars['Int']>;
  trucksShortlisted?: Maybe<Scalars['Int']>;
  truckType?: Maybe<Scalars['String']>;
  upperBidMargin?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['String']>;
  weightToLoad?: Maybe<Scalars['String']>;
};

export type OrderNode = {
  id: Scalars['ID'];
};

export type Orders = OrdersNode & {
  __typename?: 'Orders';
  bidPrice?: Maybe<Scalars['Float']>;
  cargoType?: Maybe<Scalars['String']>;
  commodity?: Maybe<Scalars['String']>;
  consignmentMetricTons?: Maybe<Scalars['Float']>;
  createdOn?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deadlineToLift?: Maybe<Scalars['Date']>;
  destination?: Maybe<Scalars['String']>;
  destinationCity?: Maybe<Scalars['String']>;
  destinationCountry?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBid?: Maybe<Scalars['Boolean']>;
  lowerBidMargin?: Maybe<Scalars['Float']>;
  lroId?: Maybe<Scalars['String']>;
  marketRate?: Maybe<Scalars['Float']>;
  maximumFuelAmount?: Maybe<Scalars['Float']>;
  origin?: Maybe<Scalars['String']>;
  originCity?: Maybe<Scalars['String']>;
  originCountry?: Maybe<Scalars['String']>;
  packagingType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  readyToLoad?: Maybe<Scalars['DateTime']>;
  region?: Maybe<Scalars['String']>;
  totalLiters?: Maybe<Scalars['Float']>;
  totalRequested?: Maybe<Scalars['Int']>;
  trailerType?: Maybe<Scalars['String']>;
  transporterPaymentTerms?: Maybe<Scalars['String']>;
  transporterRateType?: Maybe<Scalars['String']>;
  transportType?: Maybe<Scalars['String']>;
  truckList?: Maybe<Array<Maybe<Trucks>>>;
  trucksMatched?: Maybe<Scalars['Int']>;
  trucksNeeded?: Maybe<Scalars['Int']>;
  trucksShortlisted?: Maybe<Scalars['Int']>;
  truckType?: Maybe<Scalars['String']>;
  unconfirmedTrucks?: Maybe<Scalars['Int']>;
  upperBidMargin?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['String']>;
  weightToLoad?: Maybe<Scalars['String']>;
};

export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  edges: Array<Maybe<OrdersEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrdersEdge = {
  __typename?: 'OrdersEdge';
  cursor: Scalars['String'];
  node?: Maybe<Orders>;
  other?: Maybe<Scalars['String']>;
};

export type OrdersNode = {
  id: Scalars['ID'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PasswordResetLink = {
  __typename?: 'PasswordResetLink';
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type Profile = ProfileNode & {
  __typename?: 'Profile';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vettingConsent?: Maybe<Scalars['Boolean']>;
};

export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  edges: Array<Maybe<ProfileEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  cursor: Scalars['String'];
  node?: Maybe<Profile>;
  other?: Maybe<Scalars['String']>;
};

export type ProfileNode = {
  id: Scalars['ID'];
};

export enum ProfileSortEnum {
  CompanyIdAsc = 'COMPANY_ID_ASC',
  CompanyIdDesc = 'COMPANY_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IdNumberAsc = 'ID_NUMBER_ASC',
  IdNumberDesc = 'ID_NUMBER_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VettingConsentAsc = 'VETTING_CONSENT_ASC',
  VettingConsentDesc = 'VETTING_CONSENT_DESC'
}

export type RecordAllocatedWorkOrder = {
  __typename?: 'RecordAllocatedWorkOrder';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordTruckAllocation = {
  __typename?: 'RecordTruckAllocation';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordTruckDeallocation = {
  __typename?: 'RecordTruckDeallocation';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordWorkOrderDeallocation = {
  __typename?: 'RecordWorkOrderDeallocation';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordWorkOrderMatch = {
  __typename?: 'RecordWorkOrderMatch';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordWorkOrderUnMatch = {
  __typename?: 'RecordWorkOrderUnMatch';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ResetPassword = {
  __typename?: 'ResetPassword';
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type ResetPasswordInput = {
  currentPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
};

export type RootMutation = {
  __typename?: 'RootMutation';
  acceptJob?: Maybe<AcceptJob>;
  addDriver?: Maybe<AddDriver>;
  addTrailer?: Maybe<AddTrailer>;
  addTruck?: Maybe<AddTruck>;
  cancelFuelRequest?: Maybe<CancelFuelRequest>;
  cancelJob?: Maybe<CancelJob>;
  cancelRequestedJobs?: Maybe<CancelRequestedJobs>;
  confirmJob?: Maybe<ConfirmJob>;
  createCountry?: Maybe<CreateCountryPayload>;
  createErcFuelPrice?: Maybe<CreateErcFuelPricePayload>;
  createFuelRequest?: Maybe<CreateFuelRequestPayload>;
  createTracking?: Maybe<CreateTracking>;
  deleteAccount?: Maybe<DeleteAccountPayload>;
  deleteAvatar?: Maybe<DeleteUserAttributePayload>;
  deleteCompany?: Maybe<DeleteCompanyPayload>;
  deleteCompanyDetails?: Maybe<DeleteCompanyDetailsPayload>;
  deleteContact?: Maybe<DeleteContactPayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  deleteDocuments?: Maybe<DeleteDocumentPayload>;
  deleteErcFuelPrice?: Maybe<DeleteErcFuelPricePayload>;
  deleteFleet?: Maybe<DeleteFleetPayload>;
  deleteFuelRequest?: Maybe<DeleteFuelRequestPayload>;
  deleteInsurance?: Maybe<DeleteInsurancePayload>;
  deleteProfile?: Maybe<DeleteProfilePayload>;
  importDrivers?: Maybe<ImportDriver>;
  importTrailers?: Maybe<ImportTrailer>;
  importTrucks?: Maybe<ImportTruck>;
  passwordResetLink?: Maybe<PasswordResetLink>;
  recordAllocatedWorkOrder?: Maybe<RecordAllocatedWorkOrder>;
  recordDeallocatedWorkOrder?: Maybe<RecordWorkOrderDeallocation>;
  recordTruckAllocation?: Maybe<RecordTruckAllocation>;
  recordTruckDeallocation?: Maybe<RecordTruckDeallocation>;
  recordWorkOrderMatch?: Maybe<RecordWorkOrderMatch>;
  recordWorkOrderUnMatch?: Maybe<RecordWorkOrderUnMatch>;
  resetPassword?: Maybe<ResetPassword>;
  sendEmail?: Maybe<SendEmail>;
  submitBid?: Maybe<SubmitBid>;
  textDriver?: Maybe<TextDriver>;
  updateAccount?: Maybe<UpdateAccountPayload>;
  updateAvatar?: Maybe<UpdateUserAttributePayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  updateCompanyDetails?: Maybe<UpdateCompanyDetailsPayload>;
  updateContact?: Maybe<UpdateContactPayload>;
  updateCountry?: Maybe<UpdateCountryPayload>;
  updateDocuments?: Maybe<UpdateDocumentPayload>;
  updateErcFuelPrice?: Maybe<UpdateErcFuelPricePayload>;
  updateFleet?: Maybe<UpdateFleetPayload>;
  updateFuelRequest?: Maybe<UpdateFuelRequestPayload>;
  updateInsurance?: Maybe<UpdateInsurancePayload>;
  updateProfile?: Maybe<UpdateProfilePayload>;
  uploadAvatar?: Maybe<CreateUserAttributePayload>;
};


export type RootMutationAcceptJobArgs = {
  assetList: Array<InputMaybe<AssetList>>;
  lroId: Scalars['String'];
};


export type RootMutationAddDriverArgs = {
  input: DriverInput;
};


export type RootMutationAddTrailerArgs = {
  input: TrailerInput;
};


export type RootMutationAddTruckArgs = {
  input: TruckInput;
};


export type RootMutationCancelFuelRequestArgs = {
  moveId: Scalars['ID'];
};


export type RootMutationCancelJobArgs = {
  id: Scalars['Int'];
};


export type RootMutationCancelRequestedJobsArgs = {
  input?: InputMaybe<WorkOrderInput>;
};


export type RootMutationConfirmJobArgs = {
  assets: Array<InputMaybe<ConfirmAssetList>>;
};


export type RootMutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type RootMutationCreateErcFuelPriceArgs = {
  input: CreateErcFuelPriceInput;
};


export type RootMutationCreateFuelRequestArgs = {
  input: CreateFuelRequestInput;
};


export type RootMutationCreateTrackingArgs = {
  geoLocation?: InputMaybe<GeoLocationInput>;
  locationName?: InputMaybe<Scalars['String']>;
  moveId?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<TrackingSource>;
  truckId: Scalars['Int'];
  truckReg?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};


export type RootMutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type RootMutationDeleteAvatarArgs = {
  input: DeleteUserAttributeInput;
};


export type RootMutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type RootMutationDeleteCompanyDetailsArgs = {
  input: DeleteCompanyDetailsInput;
};


export type RootMutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type RootMutationDeleteCountryArgs = {
  input: DeleteCountryInput;
};


export type RootMutationDeleteDocumentsArgs = {
  input: DeleteDocumentInput;
};


export type RootMutationDeleteErcFuelPriceArgs = {
  input: DeleteErcFuelPriceInput;
};


export type RootMutationDeleteFleetArgs = {
  input: DeleteFleetInput;
};


export type RootMutationDeleteFuelRequestArgs = {
  input: DeleteFuelRequestInput;
};


export type RootMutationDeleteInsuranceArgs = {
  input: DeleteInsuranceInput;
};


export type RootMutationDeleteProfileArgs = {
  input: DeleteProfileInput;
};


export type RootMutationImportDriversArgs = {
  csvFile: Scalars['Upload'];
};


export type RootMutationImportTrailersArgs = {
  csvFile: Scalars['Upload'];
};


export type RootMutationImportTrucksArgs = {
  csvFile: Scalars['Upload'];
};


export type RootMutationPasswordResetLinkArgs = {
  email: Scalars['String'];
};


export type RootMutationRecordAllocatedWorkOrderArgs = {
  input?: InputMaybe<WorkOrderInput>;
};


export type RootMutationRecordDeallocatedWorkOrderArgs = {
  input?: InputMaybe<WorkOrderDeallocationInput>;
};


export type RootMutationRecordTruckAllocationArgs = {
  input?: InputMaybe<SupplyInput>;
};


export type RootMutationRecordTruckDeallocationArgs = {
  input?: InputMaybe<TruckDeallocationInput>;
};


export type RootMutationRecordWorkOrderMatchArgs = {
  input?: InputMaybe<MatchInput>;
};


export type RootMutationRecordWorkOrderUnMatchArgs = {
  input?: InputMaybe<WorkOrderUnMatchInput>;
};


export type RootMutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type RootMutationSendEmailArgs = {
  bodyHtml: Scalars['String'];
  bodyText: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};


export type RootMutationSubmitBidArgs = {
  assetList: Array<InputMaybe<AssetList>>;
  bidPrice: Scalars['Float'];
  lroId: Scalars['String'];
};


export type RootMutationTextDriverArgs = {
  mobileNumber?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type RootMutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type RootMutationUpdateAvatarArgs = {
  input: UpdateUserAttributeInput;
};


export type RootMutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type RootMutationUpdateCompanyDetailsArgs = {
  input: UpdateCompanyDetailsInput;
};


export type RootMutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type RootMutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type RootMutationUpdateDocumentsArgs = {
  input: UpdateDocumentInput;
};


export type RootMutationUpdateErcFuelPriceArgs = {
  input: UpdateErcFuelPriceInput;
};


export type RootMutationUpdateFleetArgs = {
  input: UpdateFleetInput;
};


export type RootMutationUpdateFuelRequestArgs = {
  input: UpdateFuelRequestInput;
};


export type RootMutationUpdateInsuranceArgs = {
  input: UpdateInsuranceInput;
};


export type RootMutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type RootMutationUploadAvatarArgs = {
  input: CreateUserAttributeInput;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  acceptedJobHistory?: Maybe<JobModelConnection>;
  account?: Maybe<Account>;
  accountById?: Maybe<Account>;
  allDrivers?: Maybe<Drivers>;
  allFuelStations?: Maybe<FuelStationConnection>;
  allTrailers?: Maybe<Trailers>;
  allTrucks?: Maybe<Trucks_>;
  banks?: Maybe<BanksConnection>;
  bidHistory?: Maybe<JobModelConnection>;
  companies?: Maybe<CompanyConnection>;
  company?: Maybe<Company>;
  companyDetails?: Maybe<CompanyDetail>;
  contact?: Maybe<Contact>;
  contactById?: Maybe<Contact>;
  contacts?: Maybe<ContactConnection>;
  directors?: Maybe<Director>;
  document?: Maybe<Document>;
  documentById?: Maybe<Document>;
  drivers?: Maybe<Drivers>;
  enterpriseTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  ercFuelPrice?: Maybe<ErcFuelPrice>;
  ercFuelPrices?: Maybe<ErcFuelPriceConnection>;
  fuelingHistory?: Maybe<FuelingDataConnection>;
  fuelRequests?: Maybe<FuelRequestConnection>;
  fuelStations?: Maybe<FuelStationConnection>;
  getAuthKey?: Maybe<AuthTokens>;
  getAvatar?: Maybe<UserAttribute>;
  getAvatarById?: Maybe<UserAttribute>;
  getCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  getTrailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  getTruckTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  globalOperation?: Maybe<Operation>;
  insurance?: Maybe<Insurance>;
  insuranceById?: Maybe<Insurance>;
  insuranceList?: Maybe<InsuranceConnection>;
  job?: Maybe<Move>;
  jobById?: Maybe<JobModel>;
  jobList?: Maybe<OrdersConnection>;
  maxFuelLimit?: Maybe<FuelLimits>;
  move?: Maybe<Move>;
  moves?: Maybe<MovesConnection>;
  myjobList?: Maybe<MovesConnection>;
  node?: Maybe<Node>;
  profile?: Maybe<Profile>;
  profileById?: Maybe<Profile>;
  profiles?: Maybe<ProfileConnection>;
  trackingRecords?: Maybe<TrackingConnectionsConnection>;
  trailers?: Maybe<Trailers>;
  trucks?: Maybe<Trucks_>;
  userAttributes?: Maybe<UserAttributeConnection>;
  userInfo?: Maybe<User>;
  userProfile?: Maybe<UserProfile>;
  workOrder?: Maybe<Order>;
};


export type RootQueryAcceptedJobHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<JobModelSortEnum>>>;
};


export type RootQueryAccountByIdArgs = {
  id: Scalars['Int'];
};


export type RootQueryAllDriversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<SourceEnum>;
};


export type RootQueryAllFuelStationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  geocode?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RootQueryAllTrailersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<SourceEnum>;
};


export type RootQueryAllTrucksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<SourceEnum>;
};


export type RootQueryBanksArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};


export type RootQueryBidHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<JobModelSortEnum>>>;
};


export type RootQueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<CompanySortEnum>>>;
};


export type RootQueryCompanyArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type RootQueryContactByIdArgs = {
  id: Scalars['Int'];
};


export type RootQueryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ContactSortEnum>>>;
};


export type RootQueryDocumentByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type RootQueryDriversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
};


export type RootQueryErcFuelPriceArgs = {
  id: Scalars['Int'];
};


export type RootQueryErcFuelPricesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ErcFuelPriceSortEnum>>>;
};


export type RootQueryFuelingHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  moveId?: InputMaybe<Scalars['Int']>;
  truckReg?: InputMaybe<Scalars['String']>;
};


export type RootQueryFuelRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  transporterId?: InputMaybe<Scalars['Int']>;
  woId?: InputMaybe<Scalars['Int']>;
};


export type RootQueryFuelStationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  moveId: Scalars['Int'];
};


export type RootQueryGetAuthKeyArgs = {
  app?: InputMaybe<AppEnum>;
};


export type RootQueryGetAvatarByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type RootQueryGlobalOperationArgs = {
  moveId?: InputMaybe<Scalars['Int']>;
};


export type RootQueryInsuranceByIdArgs = {
  id: Scalars['Int'];
};


export type RootQueryInsuranceListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<InsuranceSortEnum>>>;
};


export type RootQueryJobArgs = {
  moveId: Scalars['Int'];
};


export type RootQueryJobByIdArgs = {
  id: Scalars['Int'];
};


export type RootQueryJobListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cargoType?: InputMaybe<CargoType>;
  first?: InputMaybe<Scalars['Int']>;
  jobCategory: JobCategory;
  last?: InputMaybe<Scalars['Int']>;
  moveType?: InputMaybe<MoveType>;
  searchStr?: InputMaybe<Scalars['String']>;
};


export type RootQueryMaxFuelLimitArgs = {
  moveId?: InputMaybe<Scalars['Int']>;
};


export type RootQueryMoveArgs = {
  moveId: Scalars['Int'];
};


export type RootQueryMovesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RootQueryMyjobListArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  cargoType?: InputMaybe<CargoType>;
  first?: InputMaybe<Scalars['Int']>;
  jobCategory: JobCategory;
  last?: InputMaybe<Scalars['Int']>;
  moveType?: InputMaybe<MoveType>;
  searchStr?: InputMaybe<Scalars['String']>;
};


export type RootQueryNodeArgs = {
  id: Scalars['ID'];
};


export type RootQueryProfileByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type RootQueryProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<ProfileSortEnum>>>;
};


export type RootQueryTrackingRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationName?: InputMaybe<Scalars['String']>;
  moveId?: InputMaybe<Scalars['Int']>;
  truckId?: InputMaybe<Scalars['Int']>;
};


export type RootQueryTrailersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
};


export type RootQueryTrucksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
};


export type RootQueryUserAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<UserAttributeSortEnum>>>;
};


export type RootQueryWorkOrderArgs = {
  bidPrice?: InputMaybe<Scalars['Float']>;
  isBid?: InputMaybe<Scalars['Boolean']>;
  jobCategory: JobCategory;
  lroId?: InputMaybe<Scalars['String']>;
  moveId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type SendEmail = {
  __typename?: 'SendEmail';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export enum SourceEnum {
  LtaAdmin = 'LTA_ADMIN'
}

export type SubmitAvailableTrucks = {
  __typename?: 'SubmitAvailableTrucks';
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
  truckSupply?: Maybe<Scalars['String']>;
};

export type SubmitBid = {
  __typename?: 'SubmitBid';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type SupplyInput = {
  allocated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  failed?: InputMaybe<Array<InputMaybe<Scalars['JSONString']>>>;
  jobRequestId: Scalars['Int'];
  lroId?: InputMaybe<Scalars['String']>;
  transporter?: InputMaybe<Scalars['String']>;
  transporterId?: InputMaybe<Scalars['Int']>;
  truckList?: InputMaybe<Array<InputMaybe<Scalars['JSONString']>>>;
};

export type TextDriver = {
  __typename?: 'TextDriver';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type Tracking = TrackingNode & {
  __typename?: 'Tracking';
  capturedAt?: Maybe<Scalars['String']>;
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID'];
  locationName?: Maybe<Scalars['String']>;
  moveId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type TrackingConnectionsConnection = {
  __typename?: 'TrackingConnectionsConnection';
  edges: Array<Maybe<TrackingConnectionsEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TrackingConnectionsEdge = {
  __typename?: 'TrackingConnectionsEdge';
  cursor: Scalars['String'];
  node?: Maybe<Tracking>;
  other?: Maybe<Scalars['String']>;
};

export type TrackingNode = {
  id: Scalars['ID'];
};

export enum TrackingSource {
  Gps = 'GPS',
  Lda = 'LDA',
  Lia = 'LIA',
  Lta = 'LTA'
}

export type Trailer = {
  __typename?: 'Trailer';
  active?: Maybe<Scalars['Boolean']>;
  trailerCapacity?: Maybe<Scalars['String']>;
  trailerId?: Maybe<Scalars['Int']>;
  trailerRegistration?: Maybe<Scalars['String']>;
  trailerType?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
};

export type TrailerEdge = {
  __typename?: 'TrailerEdge';
  cursor: Scalars['String'];
  node?: Maybe<Trailer>;
};

export type TrailerInput = {
  trailerCapacity: Scalars['Float'];
  trailerReg: Scalars['String'];
  trailerType: Scalars['String'];
};

export type Trailers = {
  __typename?: 'Trailers';
  edges: Array<Maybe<TrailerEdge>>;
  pageInfo: AssetPageInfo;
};

export type Truck = {
  __typename?: 'Truck';
  active?: Maybe<Scalars['Boolean']>;
  assetId?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['String']>;
  lroId?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
  woid?: Maybe<Scalars['String']>;
};

export type TruckDeallocationInput = {
  jobRequestId: Scalars['Int'];
  unallocated: Array<InputMaybe<Scalars['JSONString']>>;
};

export type TruckEdge = {
  __typename?: 'TruckEdge';
  cursor: Scalars['String'];
  node?: Maybe<Truck>;
};

export type TruckInput = {
  truckCapacity?: InputMaybe<Scalars['Float']>;
  truckReg: Scalars['String'];
  truckType?: InputMaybe<Scalars['String']>;
};

export type TruckList = {
  __typename?: 'TruckList';
  createdOnLia?: Maybe<Scalars['Boolean']>;
  driverId?: Maybe<Scalars['Int']>;
  driverIdNumber?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['String']>;
  jobRequestId?: Maybe<Scalars['Int']>;
  trailerReg?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
};

export type Trucks = {
  __typename?: 'Trucks';
  createdOnLia?: Maybe<Scalars['Boolean']>;
  driverId?: Maybe<Scalars['Int']>;
  driverIdNumber?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  etaLoadingPoint?: Maybe<Scalars['String']>;
  trailerReg?: Maybe<Scalars['String']>;
  truckReg?: Maybe<Scalars['String']>;
};

export type Trucks_ = {
  __typename?: 'Trucks_';
  edges: Array<Maybe<TruckEdge>>;
  pageInfo: AssetPageInfo;
};

export type UpdateAccountInput = {
  accountName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  bankAddress?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  beneficiaryAddress?: InputMaybe<Scalars['String']>;
  beneficiaryName?: InputMaybe<Scalars['String']>;
  branchName?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  swiftCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account?: Maybe<Account>;
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyDetailsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  dateEstablished?: InputMaybe<Scalars['DateTime']>;
  directorDetails?: InputMaybe<Array<InputMaybe<DirectorDetailsInput>>>;
  enterpriseType?: InputMaybe<Scalars['String']>;
  numberOfDirectors?: InputMaybe<Scalars['Int']>;
  physicalAddress?: InputMaybe<Scalars['String']>;
  postalAddress?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  tradingName?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyDetailsPayload = {
  __typename?: 'UpdateCompanyDetailsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  companyDetail?: Maybe<CompanyDetail>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type UpdateCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyEmail?: InputMaybe<Scalars['String']>;
  companyMobile?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  fleet?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  region?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type UpdateContactInput = {
  adminContactName?: InputMaybe<Scalars['String']>;
  adminEmail?: InputMaybe<Scalars['String']>;
  adminTelNumber?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  operationsContactName?: InputMaybe<Scalars['String']>;
  operationsEmail?: InputMaybe<Scalars['String']>;
  operationsTelNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCountryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryIsoCode?: InputMaybe<Scalars['String']>;
  countryRegion?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type UpdateCountryPayload = {
  __typename?: 'UpdateCountryPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateDocumentInput = {
  bankLetter?: InputMaybe<Scalars['Upload']>;
  beeCertificate?: InputMaybe<Scalars['Upload']>;
  carrierResolution?: InputMaybe<Scalars['Upload']>;
  carriersLiability?: InputMaybe<Scalars['Upload']>;
  carriersLiabilityExpiry?: InputMaybe<Scalars['Date']>;
  certificateOfIncorporation?: InputMaybe<Scalars['Upload']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyLetterhead?: InputMaybe<Scalars['Upload']>;
  directorIdentification?: InputMaybe<Scalars['Upload']>;
  directorKraPin?: InputMaybe<Scalars['Upload']>;
  directorsIds?: InputMaybe<Scalars['Upload']>;
  gitCoverConfirmation?: InputMaybe<Scalars['Upload']>;
  gitCoverExpiry?: InputMaybe<Scalars['Date']>;
  goodsInTransitCertificate?: InputMaybe<Scalars['Upload']>;
  hasQualityManagementCert?: InputMaybe<Scalars['Boolean']>;
  insurancePolicies?: InputMaybe<Scalars['Upload']>;
  isVatRegistered?: InputMaybe<Scalars['Boolean']>;
  kraPin?: InputMaybe<Scalars['Upload']>;
  kraTcc?: InputMaybe<Scalars['Upload']>;
  letterOfGoodStanding?: InputMaybe<Scalars['Upload']>;
  proofOfDirectorship?: InputMaybe<Scalars['Upload']>;
  qualityManagementCertificate?: InputMaybe<Scalars['Upload']>;
  registrationCertificate?: InputMaybe<Scalars['Upload']>;
  signedLoriContract?: InputMaybe<Scalars['Upload']>;
  taxClearanceCertificate?: InputMaybe<Scalars['Upload']>;
  tin?: InputMaybe<Scalars['Upload']>;
  vatCertificate?: InputMaybe<Scalars['Upload']>;
  vatRegistrationNumber?: InputMaybe<Scalars['String']>;
  vehicleRegistrationDocuments?: InputMaybe<Scalars['Upload']>;
};

export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  documents?: Maybe<Document>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateErcFuelPriceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  price?: InputMaybe<Scalars['Float']>;
};

export type UpdateErcFuelPricePayload = {
  __typename?: 'UpdateERCFuelPricePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  contact?: Maybe<ErcFuelPrice>;
  ercFuelPrice?: Maybe<ErcFuelPrice>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateFleetInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fleetType: Scalars['String'];
  id: Scalars['Int'];
};

export type UpdateFleetPayload = {
  __typename?: 'UpdateFleetPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fleet?: Maybe<Fleet>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateFuelRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fuelAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  isCancelled?: InputMaybe<Scalars['Boolean']>;
  requestDate?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateFuelRequestPayload = {
  __typename?: 'UpdateFuelRequestPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  fuelRequest?: Maybe<FuelRequest>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateInsuranceInput = {
  broker?: InputMaybe<Scalars['String']>;
  brokerContactName?: InputMaybe<Scalars['String']>;
  brokerEmail?: InputMaybe<Scalars['String']>;
  brokerTelNumber?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  gitCoverPerLoad?: InputMaybe<Scalars['String']>;
  hasComprehensiveGitCover?: InputMaybe<Scalars['Boolean']>;
  hasPublicLiabilityInsurance?: InputMaybe<Scalars['Boolean']>;
  insuranceCompany?: InputMaybe<Scalars['String']>;
  policyNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateInsurancePayload = {
  __typename?: 'UpdateInsurancePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  insurance?: Maybe<Insurance>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  vettingConsent?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  profile?: Maybe<Profile>;
};

export type UpdateUserAttributeInput = {
  avatar?: InputMaybe<Scalars['Upload']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateUserAttributePayload = {
  __typename?: 'UpdateUserAttributePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
  userAttribute?: Maybe<UserAttribute>;
};

export type User = {
  __typename?: 'User';
  accepted_terms?: Maybe<Scalars['Boolean']>;
  account_suspended?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['Int']>;
  company_mobile?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  country_iso_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  first_login?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id_number?: Maybe<Scalars['String']>;
  is_oauth?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  preferred_username?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['Int']>;
  suspension_reason?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  transporter_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserAttribute = UserAttributeNode & {
  __typename?: 'UserAttribute';
  avatar?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserAttributeConnection = {
  __typename?: 'UserAttributeConnection';
  edges: Array<Maybe<UserAttributeEdge>>;
  extra?: Maybe<Scalars['String']>;
  pageInfo: PageInfo;
};

export type UserAttributeEdge = {
  __typename?: 'UserAttributeEdge';
  cursor: Scalars['String'];
  node?: Maybe<UserAttribute>;
  other?: Maybe<Scalars['String']>;
};

export type UserAttributeNode = {
  id: Scalars['ID'];
};

export enum UserAttributeSortEnum {
  AvatarAsc = 'AVATAR_ASC',
  AvatarDesc = 'AVATAR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type UserProfile = {
  __typename?: 'UserProfile';
  accepted_terms?: Maybe<Scalars['Boolean']>;
  account_suspended?: Maybe<Scalars['Boolean']>;
  company_id?: Maybe<Scalars['Int']>;
  company_mobile?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  country_iso_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  first_login?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  id_number?: Maybe<Scalars['String']>;
  is_oauth?: Maybe<Scalars['Boolean']>;
  last_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  missing?: Maybe<Array<Maybe<DocumentProps>>>;
  preferred_username?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
  status?: Maybe<Scalars['Int']>;
  suspension_reason?: Maybe<Scalars['String']>;
  transporter?: Maybe<Scalars['String']>;
  transporter_id?: Maybe<Scalars['Int']>;
  uploaded?: Maybe<Array<Maybe<DocumentProps>>>;
  user_id?: Maybe<Scalars['String']>;
};

export type WorkOrderDeallocationInput = {
  lroId: Scalars['String'];
  moveIds: Array<InputMaybe<Scalars['Int']>>;
  transporter: Scalars['String'];
};

export type WorkOrderInput = {
  jobRequestId: Scalars['Int'];
  lroId: Scalars['String'];
  moveIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  transporter: Scalars['String'];
};

export type WorkOrderUnMatchInput = {
  jobRequestId: Scalars['Int'];
  unmatched: Array<InputMaybe<Scalars['JSONString']>>;
};

export type CancelFuelRequestMutationVariables = Exact<{
  moveId: Scalars['ID'];
}>;


export type CancelFuelRequestMutation = { __typename?: 'RootMutation', cancelFuelRequest?: { __typename?: 'CancelFuelRequest', message?: string | null | undefined } | null | undefined };

export type ActiveJobDetailsFragment = { __typename?: 'Move', origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, moveId?: number | null | undefined, truckReg?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, trailerNumber?: string | null | undefined, lastKnownLocation?: string | null | undefined };

export type BankDetailsFragment = { __typename?: 'Banks', id: string, uuid?: string | null | undefined, bankCode?: string | null | undefined, bankName?: string | null | undefined, country?: CountryEnum | null | undefined, clearingCode?: string | null | undefined, active?: boolean | null | undefined };

export type CompletedJobDetailsFragment = { __typename?: 'Move', moveId?: number | null | undefined, truckReg?: string | null | undefined, trailerNumber?: string | null | undefined, destination?: string | null | undefined, transporterRate?: number | null | undefined, transporterCurrency?: string | null | undefined, transporterRateType?: string | null | undefined };

export type ConfirmedJobDetailsFragment = { __typename?: 'Move', origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, etaLoadingPoint?: any | null | undefined, moveId?: number | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, weight?: string | null | undefined, truckReg?: string | null | undefined, lowerBidMargin?: number | null | undefined, upperBidMargin?: number | null | undefined, currency?: string | null | undefined, phoneNumber?: string | null | undefined };

export type DriverDetailsFragment = { __typename?: 'Driver', driverId?: number | null | undefined, driverName?: string | null | undefined, driverIdNumber?: string | null | undefined, name?: string | null | undefined, countryCode?: string | null | undefined, driverPhoneNumber?: string | null | undefined, transporterId?: number | null | undefined, transporter?: string | null | undefined, active?: boolean | null | undefined };

export type FuelCardFragment = { __typename?: 'FuelingData', id: string, moveId?: number | null | undefined, lroId?: number | null | undefined, fuelStation?: string | null | undefined, truckReg?: string | null | undefined, transporterId?: number | null | undefined, fuelRequestAmount?: number | null | undefined, amountFuelled?: number | null | undefined, deplorifs?: any | null | undefined, fuelreqsent?: any | null | undefined, fuelType?: string | null | undefined, fuelStationPrice?: number | null | undefined, fuelPriceDiscount?: number | null | undefined, fuelDataValidated?: any | null | undefined, cityLevy?: number | null | undefined, fsCountry?: string | null | undefined, vatableExclusive?: number | null | undefined, fuelreqtra?: any | null | undefined, fuelLpo?: string | null | undefined, fsInvoice?: string | null | undefined, transporterInvoice?: string | null | undefined, stageNotes?: string | null | undefined, fsCity?: string | null | undefined, approvalState?: string | null | undefined };

export type FuelRequestPayloadFragment = { __typename?: 'FuelRequest', fuelStationCode: string, truckReg: string, fuelAmount: number, requestDate?: any | null | undefined };

export type FuelStationDetailsFragment = { __typename?: 'FuelStation', id: string, name?: string | null | undefined, code?: string | null | undefined, ownerId?: number | null | undefined, ownerName?: string | null | undefined, country?: string | null | undefined, email?: string | null | undefined, city?: string | null | undefined, phone?: string | null | undefined, geoId?: string | null | undefined };

export type MoveCardDetailsFragment = { __typename?: 'Move', cargoType?: string | null | undefined, commodity?: string | null | undefined, consignee?: string | null | undefined, deadlineToLift?: any | null | undefined, destinationCity?: string | null | undefined, destinationCountry?: string | null | undefined, id: string, etaLoadingPoint?: any | null | undefined, lroId?: string | null | undefined, marketRate?: number | null | undefined, moveId?: number | null | undefined, origin?: string | null | undefined, originCity?: string | null | undefined, originCountry?: string | null | undefined, originGeocode?: string | null | undefined, readyToLoad?: any | null | undefined, transportType?: string | null | undefined, transporterRateType?: string | null | undefined, transporterPaymentTerms?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, truckReg?: string | null | undefined, weight?: string | null | undefined, trucksNeeded?: number | null | undefined, currency?: string | null | undefined, destination?: string | null | undefined, lastKnownLocation?: string | null | undefined };

export type MoveFieldsFragment = { __typename?: 'Move', id: string };

export type NewJobDetailsFragment = { __typename?: 'Move', cargoType?: string | null | undefined, origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, currency?: string | null | undefined, trucksNeeded?: number | null | undefined, trailerType?: string | null | undefined, transporterRate?: number | null | undefined, transporterRateType?: string | null | undefined, weight?: string | null | undefined, commodity?: string | null | undefined, moveId?: number | null | undefined };

export type SubmittedJobDetailsFragment = { __typename?: 'Move', cargoType?: string | null | undefined, origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, trailerType?: string | null | undefined, transporterRate?: number | null | undefined, transporterRateType?: string | null | undefined, trucksNeeded?: number | null | undefined, trucksMatched?: number | null | undefined, weight?: string | null | undefined, commodity?: string | null | undefined, currency?: string | null | undefined };

export type TrailerDetailsFragment = { __typename?: 'Trailer', trailerRegistration?: string | null | undefined, trailerType?: string | null | undefined, trailerId?: number | null | undefined, transporter?: string | null | undefined, trailerCapacity?: string | null | undefined, active?: boolean | null | undefined };

export type TruckDetailsFragment = { __typename?: 'Truck', truckReg?: string | null | undefined, transporter?: string | null | undefined, active?: boolean | null | undefined, assetId?: string | null | undefined };

export type UserInfoFragment = { __typename?: 'User', message?: string | null | undefined, status?: number | null | undefined, user_id?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, id_number?: string | null | undefined, email?: string | null | undefined, role?: Array<string | null | undefined> | null | undefined, verified?: boolean | null | undefined, region?: string | null | undefined, company_id?: number | null | undefined, created_at?: string | null | undefined, preferred_username?: string | null | undefined, first_login?: boolean | null | undefined, email_verified?: boolean | null | undefined, accepted_terms?: boolean | null | undefined, transporter?: string | null | undefined, transporter_id?: number | null | undefined, company_mobile?: string | null | undefined, country_iso_code?: string | null | undefined };

export type WorkOrderCardDetailsFragment = { __typename?: 'Order', weight?: string | null | undefined, truckType?: string | null | undefined, lroId?: string | null | undefined, transporterPaymentTerms?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, origin?: string | null | undefined, destination?: string | null | undefined, trucksNeeded?: number | null | undefined, trucksShortlisted?: number | null | undefined, readyToLoad?: any | null | undefined, isBid?: boolean | null | undefined, bidPrice?: number | null | undefined, deadlineToLift?: any | null | undefined, trailerType?: string | null | undefined, marketRate?: number | null | undefined, currency?: string | null | undefined, transporterRateType?: string | null | undefined, consignmentMetricTons?: number | null | undefined, packagingType?: string | null | undefined, weightToLoad?: string | null | undefined };

export type WorkOrderDetailsFragment = { __typename?: 'Order', id: string, lroId?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, consignmentMetricTons?: number | null | undefined, createdOn?: any | null | undefined, currency?: string | null | undefined, deadlineToLift?: any | null | undefined, origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, trucksNeeded?: number | null | undefined, totalRequested?: number | null | undefined, trucksShortlisted?: number | null | undefined, trucksMatched?: number | null | undefined, transporterRateType?: string | null | undefined, transporterPaymentTerms?: string | null | undefined, maximumFuelAmount?: number | null | undefined, totalLiters?: number | null | undefined, lowerBidMargin?: number | null | undefined, upperBidMargin?: number | null | undefined, marketRate?: number | null | undefined, packagingType?: string | null | undefined, phoneNumber?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, isBid?: boolean | null | undefined, bidPrice?: number | null | undefined, weight?: string | null | undefined, weightToLoad?: string | null | undefined, truckList?: Array<{ __typename?: 'TruckList', truckReg?: string | null | undefined, trailerReg?: string | null | undefined, driverId?: number | null | undefined, driverIdNumber?: string | null | undefined, driverName?: string | null | undefined, etaLoadingPoint?: string | null | undefined, createdOnLia?: boolean | null | undefined, jobRequestId?: number | null | undefined } | null | undefined> | null | undefined };

export type AcceptJobMutationVariables = Exact<{
  assetList: Array<Maybe<AssetList>> | Maybe<AssetList>;
  lroId: Scalars['String'];
}>;


export type AcceptJobMutation = { __typename?: 'RootMutation', acceptJob?: { __typename?: 'AcceptJob', status?: number | null | undefined, message?: string | null | undefined } | null | undefined };

export type AddDriverMutationVariables = Exact<{
  driverName: Scalars['String'];
  driverIdNumber: Scalars['String'];
  driverPhone: Scalars['String'];
}>;


export type AddDriverMutation = { __typename?: 'RootMutation', addDriver?: { __typename?: 'AddDriver', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type AddTrailerMutationVariables = Exact<{
  trailerReg: Scalars['String'];
  trailerType: Scalars['String'];
  trailerCapacity: Scalars['Float'];
}>;


export type AddTrailerMutation = { __typename?: 'RootMutation', addTrailer?: { __typename?: 'AddTrailer', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type AddTruckMutationVariables = Exact<{
  truckReg: Scalars['String'];
  truckType?: Maybe<Scalars['String']>;
}>;


export type AddTruckMutation = { __typename?: 'RootMutation', addTruck?: { __typename?: 'AddTruck', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type CancelJobMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CancelJobMutation = { __typename?: 'RootMutation', cancelJob?: { __typename?: 'CancelJob', message?: string | null | undefined, status?: number | null | undefined } | null | undefined };

export type ConfirmJobMutationVariables = Exact<{
  assets: Array<Maybe<ConfirmAssetList>> | Maybe<ConfirmAssetList>;
}>;


export type ConfirmJobMutation = { __typename?: 'RootMutation', confirmJob?: { __typename?: 'ConfirmJob', message?: string | null | undefined, status?: number | null | undefined } | null | undefined };

export type CreateFuelRequestMutationVariables = Exact<{
  input: CreateFuelRequestInput;
}>;


export type CreateFuelRequestMutation = { __typename?: 'RootMutation', createFuelRequest?: { __typename?: 'CreateFuelRequestPayload', message?: string | null | undefined } | null | undefined };

export type CreateTrackingMutationVariables = Exact<{
  truckId: Scalars['Int'];
  truckReg?: Maybe<Scalars['String']>;
  moveId?: Maybe<Scalars['Int']>;
  source?: Maybe<TrackingSource>;
  locationName?: Maybe<Scalars['String']>;
  geoLocation?: Maybe<GeoLocationInput>;
  updatedBy?: Maybe<Scalars['String']>;
}>;


export type CreateTrackingMutation = { __typename?: 'RootMutation', createTracking?: { __typename?: 'CreateTracking', status?: number | null | undefined, message?: string | null | undefined } | null | undefined };

export type ImportDriversMutationVariables = Exact<{
  csvFile: Scalars['Upload'];
}>;


export type ImportDriversMutation = { __typename?: 'RootMutation', importDrivers?: { __typename?: 'ImportDriver', ok?: boolean | null | undefined, message?: string | null | undefined, response?: any | null | undefined } | null | undefined };

export type ImportTrailersMutationVariables = Exact<{
  csvFile: Scalars['Upload'];
}>;


export type ImportTrailersMutation = { __typename?: 'RootMutation', importTrailers?: { __typename?: 'ImportTrailer', ok?: boolean | null | undefined, message?: string | null | undefined, response?: any | null | undefined } | null | undefined };

export type ImportTrucksMutationVariables = Exact<{
  csvFile: Scalars['Upload'];
}>;


export type ImportTrucksMutation = { __typename?: 'RootMutation', importTrucks?: { __typename?: 'ImportTruck', ok?: boolean | null | undefined, message?: string | null | undefined, response?: any | null | undefined } | null | undefined };

export type PasswordResetLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type PasswordResetLinkMutation = { __typename?: 'RootMutation', passwordResetLink?: { __typename?: 'PasswordResetLink', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'RootMutation', resetPassword?: { __typename?: 'ResetPassword', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type SendDriverTextMutationVariables = Exact<{
  mobileNumber?: Maybe<Scalars['String']>;
  text: Scalars['String'];
}>;


export type SendDriverTextMutation = { __typename?: 'RootMutation', textDriver?: { __typename?: 'TextDriver', message?: string | null | undefined, status?: number | null | undefined } | null | undefined };

export type SubmitBidMutationVariables = Exact<{
  lroId: Scalars['String'];
  assetList: Array<Maybe<AssetList>> | Maybe<AssetList>;
  bidPrice: Scalars['Float'];
}>;


export type SubmitBidMutation = { __typename?: 'RootMutation', submitBid?: { __typename?: 'SubmitBid', status?: number | null | undefined, message?: string | null | undefined } | null | undefined };

export type UpdateBankDetailsMutationVariables = Exact<{
  bankName?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  accountNumber: Scalars['String'];
  accountType?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  swiftCode?: Maybe<Scalars['String']>;
  bankAddress?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  beneficiaryAddress?: Maybe<Scalars['String']>;
}>;


export type UpdateBankDetailsMutation = { __typename?: 'RootMutation', updateAccount?: { __typename?: 'UpdateAccountPayload', ok?: boolean | null | undefined, message?: string | null | undefined, account?: { __typename?: 'Account', id: string } | null | undefined } | null | undefined };

export type UpdateAvatarMutationVariables = Exact<{
  avatar?: Maybe<Scalars['Upload']>;
}>;


export type UpdateAvatarMutation = { __typename?: 'RootMutation', updateAvatar?: { __typename?: 'UpdateUserAttributePayload', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type UpdateCompanyDetailsMutationVariables = Exact<{
  tradingName?: Maybe<Scalars['String']>;
  enterpriseType?: Maybe<Scalars['String']>;
  postalAddress?: Maybe<Scalars['String']>;
  physicalAddress?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  dateEstablished?: Maybe<Scalars['DateTime']>;
  numberOfDirectors?: Maybe<Scalars['Int']>;
  directorDetails?: Maybe<Array<Maybe<DirectorDetailsInput>> | Maybe<DirectorDetailsInput>>;
  clientMutationId?: Maybe<Scalars['String']>;
}>;


export type UpdateCompanyDetailsMutation = { __typename?: 'RootMutation', updateCompanyDetails?: { __typename?: 'UpdateCompanyDetailsPayload', ok?: boolean | null | undefined, message?: string | null | undefined, companyDetail?: { __typename?: 'CompanyDetail', id: string } | null | undefined } | null | undefined };

export type UpdateContactDetailsMutationVariables = Exact<{
  operationsContactName?: Maybe<Scalars['String']>;
  operationsTelNumber?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  operationsEmail?: Maybe<Scalars['String']>;
  adminContactName?: Maybe<Scalars['String']>;
  adminTelNumber?: Maybe<Scalars['String']>;
  adminEmail?: Maybe<Scalars['String']>;
}>;


export type UpdateContactDetailsMutation = { __typename?: 'RootMutation', updateContact?: { __typename?: 'UpdateContactPayload', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type UpdateFuelRequestMutationVariables = Exact<{
  id: Scalars['Int'];
  fuelAmount: Scalars['Float'];
  requestDate?: Maybe<Scalars['DateTime']>;
}>;


export type UpdateFuelRequestMutation = { __typename?: 'RootMutation', updateFuelRequest?: { __typename?: 'UpdateFuelRequestPayload', ok?: boolean | null | undefined, message?: string | null | undefined, fuelRequest?: { __typename?: 'FuelRequest', fuelStationCode: string, truckReg: string, fuelAmount: number, requestDate?: any | null | undefined } | null | undefined } | null | undefined };

export type UpdateInsuranceDetailsMutationVariables = Exact<{
  broker?: Maybe<Scalars['String']>;
  brokerContactName?: Maybe<Scalars['String']>;
  brokerTelNumber?: Maybe<Scalars['String']>;
  brokerEmail?: Maybe<Scalars['String']>;
  insuranceCompany?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  hasComprehensiveGitCover?: Maybe<Scalars['Boolean']>;
  gitCoverPerLoad?: Maybe<Scalars['String']>;
  hasPublicLiabilityInsurance?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateInsuranceDetailsMutation = { __typename?: 'RootMutation', updateInsurance?: { __typename?: 'UpdateInsurancePayload', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type UpdatePersonalInfoMutationVariables = Exact<{
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  vettingConsent?: Maybe<Scalars['Boolean']>;
}>;


export type UpdatePersonalInfoMutation = { __typename?: 'RootMutation', updateProfile?: { __typename?: 'UpdateProfilePayload', ok?: boolean | null | undefined, message?: string | null | undefined, profile?: { __typename?: 'Profile', id: string } | null | undefined } | null | undefined };

export type UploadAvatarMutationVariables = Exact<{
  avatar: Scalars['Upload'];
}>;


export type UploadAvatarMutation = { __typename?: 'RootMutation', uploadAvatar?: { __typename?: 'CreateUserAttributePayload', ok?: boolean | null | undefined, message?: string | null | undefined } | null | undefined };

export type GetAccountDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountDetailsQuery = { __typename?: 'RootQuery', account?: { __typename?: 'Account', bankName?: string | null | undefined, accountName?: string | null | undefined, accountNumber?: string | null | undefined, accountType?: string | null | undefined, bankCode?: string | null | undefined, branchName?: string | null | undefined, swiftCode?: string | null | undefined, bankAddress?: string | null | undefined, beneficiaryName?: string | null | undefined, beneficiaryAddress?: string | null | undefined, currency?: string | null | undefined } | null | undefined };

export type GetActiveJobDetailsQueryVariables = Exact<{
  moveId: Scalars['Int'];
}>;


export type GetActiveJobDetailsQuery = { __typename?: 'RootQuery', move?: { __typename?: 'Move', origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, moveId?: number | null | undefined, truckReg?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, trailerNumber?: string | null | undefined, lastKnownLocation?: string | null | undefined } | null | undefined };

export type GetAuthKeyQueryVariables = Exact<{
  app?: Maybe<AppEnum>;
}>;


export type GetAuthKeyQuery = { __typename?: 'RootQuery', getAuthKey?: { __typename?: 'AuthTokens', AccessToken?: string | null | undefined, RefreshToken?: string | null | undefined, ExpiresIn?: number | null | undefined } | null | undefined };

export type GetAvailableDriversQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableDriversQuery = { __typename?: 'RootQuery', drivers?: { __typename?: 'Drivers', edges: Array<{ __typename?: 'DriverEdge', node?: { __typename?: 'Driver', driverId?: number | null | undefined, driverName?: string | null | undefined, driverIdNumber?: string | null | undefined, name?: string | null | undefined, countryCode?: string | null | undefined, driverPhoneNumber?: string | null | undefined, transporterId?: number | null | undefined, transporter?: string | null | undefined, active?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetAvailableTrailersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableTrailersQuery = { __typename?: 'RootQuery', trailers?: { __typename?: 'Trailers', edges: Array<{ __typename?: 'TrailerEdge', node?: { __typename?: 'Trailer', trailerRegistration?: string | null | undefined, trailerType?: string | null | undefined, trailerId?: number | null | undefined, transporter?: string | null | undefined, trailerCapacity?: string | null | undefined, active?: boolean | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetAvailableTrucksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableTrucksQuery = { __typename?: 'RootQuery', trucks?: { __typename?: 'Trucks_', edges: Array<{ __typename?: 'TruckEdge', node?: { __typename?: 'Truck', truckReg?: string | null | undefined, transporter?: string | null | undefined, active?: boolean | null | undefined, assetId?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetAvatarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvatarQuery = { __typename?: 'RootQuery', getAvatar?: { __typename?: 'UserAttribute', id: string, avatar?: string | null | undefined } | null | undefined };

export type GetBankDetailsQueryVariables = Exact<{
  countryCode?: Maybe<Scalars['String']>;
}>;


export type GetBankDetailsQuery = { __typename?: 'RootQuery', banks?: { __typename?: 'BanksConnection', totalCount: number, edges: Array<{ __typename?: 'BanksEdge', node?: { __typename?: 'Banks', id: string, bankName?: string | null | undefined, bankCode?: string | null | undefined, country?: CountryEnum | null | undefined, active?: boolean | null | undefined, uuid?: string | null | undefined, clearingCode?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetCompanyDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyDetailsQuery = { __typename?: 'RootQuery', companyDetails?: { __typename?: 'CompanyDetail', id: string, tradingName?: string | null | undefined, enterpriseType?: string | null | undefined, postalAddress?: string | null | undefined, physicalAddress?: string | null | undefined, registrationNumber?: string | null | undefined, dateEstablished?: any | null | undefined, numberOfDirectors?: number | null | undefined, company?: { __typename?: 'Company', directors?: { __typename?: 'DirectorConnection', edges: Array<{ __typename?: 'DirectorEdge', node?: { __typename?: 'Director', directorName?: string | null | undefined, directorNumber?: string | null | undefined, directorResidentialAddress?: string | null | undefined, directorTelNumber?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined } | null | undefined } | null | undefined };

export type GetCompletedJobDetailsQueryVariables = Exact<{
  moveId: Scalars['Int'];
}>;


export type GetCompletedJobDetailsQuery = { __typename?: 'RootQuery', move?: { __typename?: 'Move', moveId?: number | null | undefined, truckReg?: string | null | undefined, trailerNumber?: string | null | undefined, destination?: string | null | undefined, transporterRate?: number | null | undefined, transporterCurrency?: string | null | undefined, transporterRateType?: string | null | undefined } | null | undefined };

export type GetConfirmedJobDetailsQueryVariables = Exact<{
  moveId: Scalars['Int'];
}>;


export type GetConfirmedJobDetailsQuery = { __typename?: 'RootQuery', job?: { __typename?: 'Move', origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, etaLoadingPoint?: any | null | undefined, moveId?: number | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, weight?: string | null | undefined, truckReg?: string | null | undefined, lowerBidMargin?: number | null | undefined, upperBidMargin?: number | null | undefined, currency?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined };

export type GetContactDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactDetailsQuery = { __typename?: 'RootQuery', contact?: { __typename?: 'Contact', id: string, operationsContactName?: string | null | undefined, operationsTelNumber?: string | null | undefined, mobileNumber?: string | null | undefined, operationsEmail?: string | null | undefined, adminContactName?: string | null | undefined, adminTelNumber?: string | null | undefined, adminEmail?: string | null | undefined } | null | undefined };

export type GetFuelRequestsQueryVariables = Exact<{
  moveId?: Maybe<Scalars['Int']>;
  transporterId?: Maybe<Scalars['Int']>;
}>;


export type GetFuelRequestsQuery = { __typename?: 'RootQuery', fuelRequests?: { __typename?: 'FuelRequestConnection', edges: Array<{ __typename?: 'FuelRequestEdge', node?: { __typename?: 'FuelRequest', amountFuelled?: number | null | undefined, fuelRequestAmount?: number | null | undefined, fuelStation?: string | null | undefined, fuelStationId?: number | null | undefined, fuelType?: string | null | undefined, lroId: string, moveId: number, truckReg: string, transporterId: number, approvalState?: string | null | undefined, fuelreqtra?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetFuelLimitQueryVariables = Exact<{
  moveId?: Maybe<Scalars['Int']>;
}>;


export type GetFuelLimitQuery = { __typename?: 'RootQuery', maxFuelLimit?: { __typename?: 'FuelLimits', waFuelOptions?: Array<number | null | undefined> | null | undefined, maxFuelAmount?: number | null | undefined } | null | undefined };

export type GetFuelStationListQueryVariables = Exact<{
  moveId: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type GetFuelStationListQuery = { __typename?: 'RootQuery', fuelStations?: { __typename?: 'FuelStationConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'FuelStationEdge', node?: { __typename?: 'FuelStation', id: string, name?: string | null | undefined, code?: string | null | undefined, ownerId?: number | null | undefined, ownerName?: string | null | undefined, country?: string | null | undefined, email?: string | null | undefined, city?: string | null | undefined, phone?: string | null | undefined, geoId?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetInsuranceDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceDetailsQuery = { __typename?: 'RootQuery', insurance?: { __typename?: 'Insurance', id: string, broker?: string | null | undefined, brokerContactName?: string | null | undefined, brokerTelNumber?: string | null | undefined, brokerEmail?: string | null | undefined, insuranceCompany?: string | null | undefined, policyNumber?: string | null | undefined, hasComprehensiveGitCover?: boolean | null | undefined, gitCoverPerLoad?: string | null | undefined, hasPublicLiabilityInsurance?: boolean | null | undefined } | null | undefined };

export type GetMoveListQueryVariables = Exact<{
  jobCategory: JobCategory;
  searchStr?: Maybe<Scalars['String']>;
  cargoType?: Maybe<CargoType>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  moveType?: Maybe<MoveType>;
}>;


export type GetMoveListQuery = { __typename?: 'RootQuery', myjobList?: { __typename?: 'MovesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'MovesEdge', node?: { __typename?: 'Move', cargoType?: string | null | undefined, commodity?: string | null | undefined, consignee?: string | null | undefined, deadlineToLift?: any | null | undefined, destinationCity?: string | null | undefined, destinationCountry?: string | null | undefined, id: string, etaLoadingPoint?: any | null | undefined, lroId?: string | null | undefined, marketRate?: number | null | undefined, moveId?: number | null | undefined, origin?: string | null | undefined, originCity?: string | null | undefined, originCountry?: string | null | undefined, originGeocode?: string | null | undefined, readyToLoad?: any | null | undefined, transportType?: string | null | undefined, transporterRateType?: string | null | undefined, transporterPaymentTerms?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, truckReg?: string | null | undefined, weight?: string | null | undefined, trucksNeeded?: number | null | undefined, currency?: string | null | undefined, destination?: string | null | undefined, lastKnownLocation?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetPersonalDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalDetailsQuery = { __typename?: 'RootQuery', profile?: { __typename?: 'Profile', firstName?: string | null | undefined, lastName?: string | null | undefined, idNumber?: string | null | undefined, id: string, vettingConsent?: boolean | null | undefined } | null | undefined };

export type GetTrackingRecordsQueryVariables = Exact<{
  truckId?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
}>;


export type GetTrackingRecordsQuery = { __typename?: 'RootQuery', trackingRecords?: { __typename?: 'TrackingConnectionsConnection', totalCount?: number | null | undefined, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null | undefined, endCursor?: string | null | undefined, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'TrackingConnectionsEdge', node?: { __typename?: 'Tracking', id: string, capturedAt?: string | null | undefined, locationName?: string | null | undefined, truckReg?: string | null | undefined, moveId?: number | null | undefined, updatedBy?: string | null | undefined, source?: string | null | undefined, geoLocation?: { __typename?: 'GeoLocation', latitude?: number | null | undefined, longitude?: number | null | undefined } | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type GetTrailerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrailerTypesQuery = { __typename?: 'RootQuery', getTrailerTypes?: Array<string | null | undefined> | null | undefined };

export type GetTruckTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTruckTypesQuery = { __typename?: 'RootQuery', getTruckTypes?: Array<string | null | undefined> | null | undefined };

export type GetUploadedDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUploadedDocumentsQuery = { __typename?: 'RootQuery', document?: { __typename?: 'Document', id: string, directorIdentification?: string | null | undefined, certificateOfIncorporation?: string | null | undefined, kraPin?: string | null | undefined, tin?: string | null | undefined, kraTcc?: string | null | undefined, proofOfDirectorship?: string | null | undefined, carriersLiability?: string | null | undefined, carriersLiabilityExpiry?: any | null | undefined, carrierResolution?: string | null | undefined, gitCoverConfirmation?: string | null | undefined, gitCoverExpiry?: any | null | undefined, insurancePolicies?: string | null | undefined, beeCertificate?: string | null | undefined, bankLetter?: string | null | undefined, isVatRegistered?: boolean | null | undefined, vatRegistrationNumber?: string | null | undefined, vatCertificate?: string | null | undefined, registrationCertificate?: string | null | undefined, taxClearanceCertificate?: string | null | undefined, companyLetterhead?: string | null | undefined, directorsIds?: string | null | undefined, letterOfGoodStanding?: string | null | undefined, vehicleRegistrationDocuments?: string | null | undefined, hasQualityManagementCert?: boolean | null | undefined, qualityManagementCertificate?: string | null | undefined, directorKraPin?: string | null | undefined, goodsInTransitCertificate?: string | null | undefined, signedLoriContract?: string | null | undefined } | null | undefined };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'RootQuery', userInfo?: { __typename?: 'User', message?: string | null | undefined, status?: number | null | undefined, user_id?: string | null | undefined, first_name?: string | null | undefined, last_name?: string | null | undefined, id_number?: string | null | undefined, email?: string | null | undefined, role?: Array<string | null | undefined> | null | undefined, verified?: boolean | null | undefined, region?: string | null | undefined, company_id?: number | null | undefined, created_at?: string | null | undefined, preferred_username?: string | null | undefined, first_login?: boolean | null | undefined, email_verified?: boolean | null | undefined, accepted_terms?: boolean | null | undefined, transporter?: string | null | undefined, transporter_id?: number | null | undefined, company_mobile?: string | null | undefined, country_iso_code?: string | null | undefined } | null | undefined };

export type GetWorkOrderQueryVariables = Exact<{
  isBid?: Maybe<Scalars['Boolean']>;
  bidPrice?: Maybe<Scalars['Float']>;
  jobCategory: JobCategory;
  lroId?: Maybe<Scalars['String']>;
  moveId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Float']>;
}>;


export type GetWorkOrderQuery = { __typename?: 'RootQuery', workOrder?: { __typename?: 'Order', id: string, lroId?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, consignmentMetricTons?: number | null | undefined, createdOn?: any | null | undefined, currency?: string | null | undefined, deadlineToLift?: any | null | undefined, origin?: string | null | undefined, driverIdNumber?: string | null | undefined, etaLoadingPoint?: any | null | undefined, destination?: string | null | undefined, trucksNeeded?: number | null | undefined, totalRequested?: number | null | undefined, trucksShortlisted?: number | null | undefined, trucksMatched?: number | null | undefined, transporterRateType?: string | null | undefined, transporterPaymentTerms?: string | null | undefined, maximumFuelAmount?: number | null | undefined, totalLiters?: number | null | undefined, lowerBidMargin?: number | null | undefined, upperBidMargin?: number | null | undefined, marketRate?: number | null | undefined, phoneNumber?: string | null | undefined, trailerType?: string | null | undefined, trailerTypes?: Array<string | null | undefined> | null | undefined, truckType?: string | null | undefined, isBid?: boolean | null | undefined, bidPrice?: number | null | undefined, packagingType?: string | null | undefined, weightToLoad?: string | null | undefined, weight?: string | null | undefined, readyToLoad?: any | null | undefined, lastKnownLocation?: string | null | undefined, trailerNumber?: string | null | undefined, truckReg?: string | null | undefined, moveId?: number | null | undefined, truckList?: Array<{ __typename?: 'TruckList', truckReg?: string | null | undefined, trailerReg?: string | null | undefined, driverId?: number | null | undefined, driverIdNumber?: string | null | undefined, driverName?: string | null | undefined, etaLoadingPoint?: string | null | undefined, createdOnLia?: boolean | null | undefined, jobRequestId?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetWorkOrderListQueryVariables = Exact<{
  jobCategory: JobCategory;
  searchStr?: Maybe<Scalars['String']>;
  moveType?: Maybe<MoveType>;
  cargoType?: Maybe<CargoType>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
}>;


export type GetWorkOrderListQuery = { __typename?: 'RootQuery', jobList?: { __typename?: 'OrdersConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, edges: Array<{ __typename?: 'OrdersEdge', node?: { __typename?: 'Orders', id: string, lroId?: string | null | undefined, cargoType?: string | null | undefined, commodity?: string | null | undefined, consignmentMetricTons?: number | null | undefined, createdOn?: any | null | undefined, currency?: string | null | undefined, deadlineToLift?: any | null | undefined, origin?: string | null | undefined, destination?: string | null | undefined, readyToLoad?: any | null | undefined, trucksNeeded?: number | null | undefined, totalRequested?: number | null | undefined, trucksShortlisted?: number | null | undefined, trucksMatched?: number | null | undefined, marketRate?: number | null | undefined, packagingType?: string | null | undefined, phoneNumber?: string | null | undefined, trailerType?: string | null | undefined, truckType?: string | null | undefined, isBid?: boolean | null | undefined, bidPrice?: number | null | undefined, weight?: string | null | undefined, weightToLoad?: string | null | undefined, destinationCity?: string | null | undefined, originCity?: string | null | undefined, transportType?: string | null | undefined, transporterRateType?: string | null | undefined, transporterPaymentTerms?: string | null | undefined } | null | undefined } | null | undefined> } | null | undefined };

export type OperationQueryVariables = Exact<{
  moveId: Scalars['Int'];
}>;


export type OperationQuery = { __typename?: 'RootQuery', globalOperation?: { __typename: 'Operation', moveId?: number | null | undefined, truckReg?: string | null | undefined, truck?: { __typename?: 'OperationTruck', id?: number | null | undefined } | null | undefined } | null | undefined };

export const ActiveJobDetailsFragmentDoc = gql`
    fragment activeJobDetails on Move {
  origin
  destination
  readyToLoad
  moveId
  truckReg
  trailerType
  truckType
  trailerNumber
  lastKnownLocation
}
    `;
export const BankDetailsFragmentDoc = gql`
    fragment bankDetails on Banks {
  id
  uuid
  bankCode
  bankName
  country
  clearingCode
  active
}
    `;
export const CompletedJobDetailsFragmentDoc = gql`
    fragment completedJobDetails on Move {
  moveId
  truckReg
  trailerNumber
  destination
  transporterRate
  transporterCurrency
  transporterRateType
}
    `;
export const ConfirmedJobDetailsFragmentDoc = gql`
    fragment confirmedJobDetails on Move {
  origin
  destination
  readyToLoad
  etaLoadingPoint
  moveId
  trailerType
  truckType
  cargoType
  commodity
  weight
  readyToLoad
  truckReg
  lowerBidMargin
  upperBidMargin
  currency
  phoneNumber
}
    `;
export const DriverDetailsFragmentDoc = gql`
    fragment driverDetails on Driver {
  driverId
  driverName
  driverIdNumber
  name
  countryCode
  driverPhoneNumber
  transporterId
  transporter
  active
}
    `;
export const FuelCardFragmentDoc = gql`
    fragment fuelCard on FuelingData {
  id
  moveId
  lroId
  fuelStation
  truckReg
  transporterId
  fuelRequestAmount
  amountFuelled
  deplorifs
  fuelreqsent
  fuelType
  fuelStationPrice
  fuelPriceDiscount
  fuelDataValidated
  cityLevy
  fsCountry
  vatableExclusive
  fuelreqtra
  fuelLpo
  fsInvoice
  transporterInvoice
  stageNotes
  fsCity
  approvalState
}
    `;
export const FuelRequestPayloadFragmentDoc = gql`
    fragment fuelRequestPayload on FuelRequest {
  fuelStationCode
  truckReg
  fuelAmount
  requestDate
}
    `;
export const FuelStationDetailsFragmentDoc = gql`
    fragment fuelStationDetails on FuelStation {
  id
  name
  code
  ownerId
  ownerName
  country
  email
  city
  phone
  geoId
}
    `;
export const MoveCardDetailsFragmentDoc = gql`
    fragment moveCardDetails on Move {
  cargoType
  commodity
  consignee
  deadlineToLift
  destinationCity
  destinationCountry
  id
  etaLoadingPoint
  lroId
  marketRate
  moveId
  origin
  originCity
  originCountry
  originGeocode
  readyToLoad
  transportType
  transporterRateType
  transporterPaymentTerms
  trailerType
  truckType
  truckReg
  weight
  trucksNeeded
  currency
  destination
  lastKnownLocation
}
    `;
export const MoveFieldsFragmentDoc = gql`
    fragment moveFields on Move {
  id
}
    `;
export const NewJobDetailsFragmentDoc = gql`
    fragment newJobDetails on Move {
  cargoType
  origin
  destination
  readyToLoad
  currency
  trucksNeeded
  trailerType
  transporterRate
  transporterRateType
  weight
  commodity
  moveId
}
    `;
export const SubmittedJobDetailsFragmentDoc = gql`
    fragment submittedJobDetails on Move {
  cargoType
  origin
  destination
  readyToLoad
  trailerType
  transporterRate
  transporterRateType
  trucksNeeded
  trucksMatched
  weight
  commodity
  currency
}
    `;
export const TrailerDetailsFragmentDoc = gql`
    fragment trailerDetails on Trailer {
  trailerRegistration
  trailerType
  trailerId
  transporter
  trailerCapacity
  active
}
    `;
export const TruckDetailsFragmentDoc = gql`
    fragment truckDetails on Truck {
  truckReg
  transporter
  active
  assetId
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment userInfo on User {
  message
  status
  user_id
  first_name
  last_name
  id_number
  email
  role
  verified
  region
  company_id
  created_at
  preferred_username
  first_login
  email_verified
  accepted_terms
  transporter
  transporter_id
  company_mobile
  country_iso_code
}
    `;
export const WorkOrderCardDetailsFragmentDoc = gql`
    fragment workOrderCardDetails on Order {
  weight
  truckType
  lroId
  truckType
  transporterPaymentTerms
  cargoType
  commodity
  origin
  destination
  trucksNeeded
  trucksShortlisted
  readyToLoad
  isBid
  bidPrice
  deadlineToLift
  trailerType
  marketRate
  currency
  transporterRateType
  consignmentMetricTons
  packagingType
  weightToLoad
}
    `;
export const WorkOrderDetailsFragmentDoc = gql`
    fragment workOrderDetails on Order {
  id
  lroId
  cargoType
  commodity
  consignmentMetricTons
  createdOn
  currency
  deadlineToLift
  origin
  destination
  readyToLoad
  trucksNeeded
  totalRequested
  trucksShortlisted
  trucksMatched
  transporterRateType
  transporterPaymentTerms
  maximumFuelAmount
  totalLiters
  lowerBidMargin
  upperBidMargin
  marketRate
  packagingType
  phoneNumber
  trailerType
  truckType
  isBid
  bidPrice
  weight
  weightToLoad
  truckList {
    truckReg
    trailerReg
    driverId
    driverIdNumber
    driverName
    etaLoadingPoint
    createdOnLia
    jobRequestId
  }
}
    `;
export const CancelFuelRequestDocument = gql`
    mutation cancelFuelRequest($moveId: ID!) {
  cancelFuelRequest(moveId: $moveId) {
    message
  }
}
    `;
export type CancelFuelRequestMutationFn = Apollo.MutationFunction<CancelFuelRequestMutation, CancelFuelRequestMutationVariables>;

/**
 * __useCancelFuelRequestMutation__
 *
 * To run a mutation, you first call `useCancelFuelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFuelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFuelRequestMutation, { data, loading, error }] = useCancelFuelRequestMutation({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useCancelFuelRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelFuelRequestMutation, CancelFuelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFuelRequestMutation, CancelFuelRequestMutationVariables>(CancelFuelRequestDocument, options);
      }
export type CancelFuelRequestMutationHookResult = ReturnType<typeof useCancelFuelRequestMutation>;
export type CancelFuelRequestMutationResult = Apollo.MutationResult<CancelFuelRequestMutation>;
export type CancelFuelRequestMutationOptions = Apollo.BaseMutationOptions<CancelFuelRequestMutation, CancelFuelRequestMutationVariables>;
export const AcceptJobDocument = gql`
    mutation acceptJob($assetList: [AssetList]!, $lroId: String!) {
  acceptJob(assetList: $assetList, lroId: $lroId) {
    status
    message
  }
}
    `;
export type AcceptJobMutationFn = Apollo.MutationFunction<AcceptJobMutation, AcceptJobMutationVariables>;

/**
 * __useAcceptJobMutation__
 *
 * To run a mutation, you first call `useAcceptJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptJobMutation, { data, loading, error }] = useAcceptJobMutation({
 *   variables: {
 *      assetList: // value for 'assetList'
 *      lroId: // value for 'lroId'
 *   },
 * });
 */
export function useAcceptJobMutation(baseOptions?: Apollo.MutationHookOptions<AcceptJobMutation, AcceptJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptJobMutation, AcceptJobMutationVariables>(AcceptJobDocument, options);
      }
export type AcceptJobMutationHookResult = ReturnType<typeof useAcceptJobMutation>;
export type AcceptJobMutationResult = Apollo.MutationResult<AcceptJobMutation>;
export type AcceptJobMutationOptions = Apollo.BaseMutationOptions<AcceptJobMutation, AcceptJobMutationVariables>;
export const AddDriverDocument = gql`
    mutation addDriver($driverName: String!, $driverIdNumber: String!, $driverPhone: String!) {
  addDriver(input: {driverName: $driverName, driverIdNumber: $driverIdNumber, driverPhone: $driverPhone}) {
    ok
    message
  }
}
    `;
export type AddDriverMutationFn = Apollo.MutationFunction<AddDriverMutation, AddDriverMutationVariables>;

/**
 * __useAddDriverMutation__
 *
 * To run a mutation, you first call `useAddDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDriverMutation, { data, loading, error }] = useAddDriverMutation({
 *   variables: {
 *      driverName: // value for 'driverName'
 *      driverIdNumber: // value for 'driverIdNumber'
 *      driverPhone: // value for 'driverPhone'
 *   },
 * });
 */
export function useAddDriverMutation(baseOptions?: Apollo.MutationHookOptions<AddDriverMutation, AddDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDriverMutation, AddDriverMutationVariables>(AddDriverDocument, options);
      }
export type AddDriverMutationHookResult = ReturnType<typeof useAddDriverMutation>;
export type AddDriverMutationResult = Apollo.MutationResult<AddDriverMutation>;
export type AddDriverMutationOptions = Apollo.BaseMutationOptions<AddDriverMutation, AddDriverMutationVariables>;
export const AddTrailerDocument = gql`
    mutation addTrailer($trailerReg: String!, $trailerType: String!, $trailerCapacity: Float!) {
  addTrailer(input: {trailerReg: $trailerReg, trailerType: $trailerType, trailerCapacity: $trailerCapacity}) {
    ok
    message
  }
}
    `;
export type AddTrailerMutationFn = Apollo.MutationFunction<AddTrailerMutation, AddTrailerMutationVariables>;

/**
 * __useAddTrailerMutation__
 *
 * To run a mutation, you first call `useAddTrailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrailerMutation, { data, loading, error }] = useAddTrailerMutation({
 *   variables: {
 *      trailerReg: // value for 'trailerReg'
 *      trailerType: // value for 'trailerType'
 *      trailerCapacity: // value for 'trailerCapacity'
 *   },
 * });
 */
export function useAddTrailerMutation(baseOptions?: Apollo.MutationHookOptions<AddTrailerMutation, AddTrailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrailerMutation, AddTrailerMutationVariables>(AddTrailerDocument, options);
      }
export type AddTrailerMutationHookResult = ReturnType<typeof useAddTrailerMutation>;
export type AddTrailerMutationResult = Apollo.MutationResult<AddTrailerMutation>;
export type AddTrailerMutationOptions = Apollo.BaseMutationOptions<AddTrailerMutation, AddTrailerMutationVariables>;
export const AddTruckDocument = gql`
    mutation addTruck($truckReg: String!, $truckType: String) {
  addTruck(input: {truckReg: $truckReg, truckType: $truckType}) {
    ok
    message
  }
}
    `;
export type AddTruckMutationFn = Apollo.MutationFunction<AddTruckMutation, AddTruckMutationVariables>;

/**
 * __useAddTruckMutation__
 *
 * To run a mutation, you first call `useAddTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTruckMutation, { data, loading, error }] = useAddTruckMutation({
 *   variables: {
 *      truckReg: // value for 'truckReg'
 *      truckType: // value for 'truckType'
 *   },
 * });
 */
export function useAddTruckMutation(baseOptions?: Apollo.MutationHookOptions<AddTruckMutation, AddTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTruckMutation, AddTruckMutationVariables>(AddTruckDocument, options);
      }
export type AddTruckMutationHookResult = ReturnType<typeof useAddTruckMutation>;
export type AddTruckMutationResult = Apollo.MutationResult<AddTruckMutation>;
export type AddTruckMutationOptions = Apollo.BaseMutationOptions<AddTruckMutation, AddTruckMutationVariables>;
export const CancelJobDocument = gql`
    mutation cancelJob($id: Int!) {
  cancelJob(id: $id) {
    message
    status
  }
}
    `;
export type CancelJobMutationFn = Apollo.MutationFunction<CancelJobMutation, CancelJobMutationVariables>;

/**
 * __useCancelJobMutation__
 *
 * To run a mutation, you first call `useCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJobMutation, { data, loading, error }] = useCancelJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelJobMutation, CancelJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelJobMutation, CancelJobMutationVariables>(CancelJobDocument, options);
      }
export type CancelJobMutationHookResult = ReturnType<typeof useCancelJobMutation>;
export type CancelJobMutationResult = Apollo.MutationResult<CancelJobMutation>;
export type CancelJobMutationOptions = Apollo.BaseMutationOptions<CancelJobMutation, CancelJobMutationVariables>;
export const ConfirmJobDocument = gql`
    mutation confirmJob($assets: [ConfirmAssetList]!) {
  confirmJob(assets: $assets) {
    message
    status
  }
}
    `;
export type ConfirmJobMutationFn = Apollo.MutationFunction<ConfirmJobMutation, ConfirmJobMutationVariables>;

/**
 * __useConfirmJobMutation__
 *
 * To run a mutation, you first call `useConfirmJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmJobMutation, { data, loading, error }] = useConfirmJobMutation({
 *   variables: {
 *      assets: // value for 'assets'
 *   },
 * });
 */
export function useConfirmJobMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmJobMutation, ConfirmJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmJobMutation, ConfirmJobMutationVariables>(ConfirmJobDocument, options);
      }
export type ConfirmJobMutationHookResult = ReturnType<typeof useConfirmJobMutation>;
export type ConfirmJobMutationResult = Apollo.MutationResult<ConfirmJobMutation>;
export type ConfirmJobMutationOptions = Apollo.BaseMutationOptions<ConfirmJobMutation, ConfirmJobMutationVariables>;
export const CreateFuelRequestDocument = gql`
    mutation createFuelRequest($input: CreateFuelRequestInput!) {
  createFuelRequest(input: $input) {
    message
  }
}
    `;
export type CreateFuelRequestMutationFn = Apollo.MutationFunction<CreateFuelRequestMutation, CreateFuelRequestMutationVariables>;

/**
 * __useCreateFuelRequestMutation__
 *
 * To run a mutation, you first call `useCreateFuelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFuelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFuelRequestMutation, { data, loading, error }] = useCreateFuelRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFuelRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFuelRequestMutation, CreateFuelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFuelRequestMutation, CreateFuelRequestMutationVariables>(CreateFuelRequestDocument, options);
      }
export type CreateFuelRequestMutationHookResult = ReturnType<typeof useCreateFuelRequestMutation>;
export type CreateFuelRequestMutationResult = Apollo.MutationResult<CreateFuelRequestMutation>;
export type CreateFuelRequestMutationOptions = Apollo.BaseMutationOptions<CreateFuelRequestMutation, CreateFuelRequestMutationVariables>;
export const CreateTrackingDocument = gql`
    mutation createTracking($truckId: Int!, $truckReg: String, $moveId: Int, $source: TrackingSource, $locationName: String, $geoLocation: GeoLocationInput, $updatedBy: String) {
  createTracking(truckId: $truckId, truckReg: $truckReg, moveId: $moveId, source: $source, locationName: $locationName, geoLocation: $geoLocation, updatedBy: $updatedBy) {
    status
    message
  }
}
    `;
export type CreateTrackingMutationFn = Apollo.MutationFunction<CreateTrackingMutation, CreateTrackingMutationVariables>;

/**
 * __useCreateTrackingMutation__
 *
 * To run a mutation, you first call `useCreateTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackingMutation, { data, loading, error }] = useCreateTrackingMutation({
 *   variables: {
 *      truckId: // value for 'truckId'
 *      truckReg: // value for 'truckReg'
 *      moveId: // value for 'moveId'
 *      source: // value for 'source'
 *      locationName: // value for 'locationName'
 *      geoLocation: // value for 'geoLocation'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useCreateTrackingMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackingMutation, CreateTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackingMutation, CreateTrackingMutationVariables>(CreateTrackingDocument, options);
      }
export type CreateTrackingMutationHookResult = ReturnType<typeof useCreateTrackingMutation>;
export type CreateTrackingMutationResult = Apollo.MutationResult<CreateTrackingMutation>;
export type CreateTrackingMutationOptions = Apollo.BaseMutationOptions<CreateTrackingMutation, CreateTrackingMutationVariables>;
export const ImportDriversDocument = gql`
    mutation importDrivers($csvFile: Upload!) {
  importDrivers(csvFile: $csvFile) {
    ok
    message
    response
  }
}
    `;
export type ImportDriversMutationFn = Apollo.MutationFunction<ImportDriversMutation, ImportDriversMutationVariables>;

/**
 * __useImportDriversMutation__
 *
 * To run a mutation, you first call `useImportDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importDriversMutation, { data, loading, error }] = useImportDriversMutation({
 *   variables: {
 *      csvFile: // value for 'csvFile'
 *   },
 * });
 */
export function useImportDriversMutation(baseOptions?: Apollo.MutationHookOptions<ImportDriversMutation, ImportDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportDriversMutation, ImportDriversMutationVariables>(ImportDriversDocument, options);
      }
export type ImportDriversMutationHookResult = ReturnType<typeof useImportDriversMutation>;
export type ImportDriversMutationResult = Apollo.MutationResult<ImportDriversMutation>;
export type ImportDriversMutationOptions = Apollo.BaseMutationOptions<ImportDriversMutation, ImportDriversMutationVariables>;
export const ImportTrailersDocument = gql`
    mutation importTrailers($csvFile: Upload!) {
  importTrailers(csvFile: $csvFile) {
    ok
    message
    response
  }
}
    `;
export type ImportTrailersMutationFn = Apollo.MutationFunction<ImportTrailersMutation, ImportTrailersMutationVariables>;

/**
 * __useImportTrailersMutation__
 *
 * To run a mutation, you first call `useImportTrailersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTrailersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTrailersMutation, { data, loading, error }] = useImportTrailersMutation({
 *   variables: {
 *      csvFile: // value for 'csvFile'
 *   },
 * });
 */
export function useImportTrailersMutation(baseOptions?: Apollo.MutationHookOptions<ImportTrailersMutation, ImportTrailersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTrailersMutation, ImportTrailersMutationVariables>(ImportTrailersDocument, options);
      }
export type ImportTrailersMutationHookResult = ReturnType<typeof useImportTrailersMutation>;
export type ImportTrailersMutationResult = Apollo.MutationResult<ImportTrailersMutation>;
export type ImportTrailersMutationOptions = Apollo.BaseMutationOptions<ImportTrailersMutation, ImportTrailersMutationVariables>;
export const ImportTrucksDocument = gql`
    mutation importTrucks($csvFile: Upload!) {
  importTrucks(csvFile: $csvFile) {
    ok
    message
    response
  }
}
    `;
export type ImportTrucksMutationFn = Apollo.MutationFunction<ImportTrucksMutation, ImportTrucksMutationVariables>;

/**
 * __useImportTrucksMutation__
 *
 * To run a mutation, you first call `useImportTrucksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTrucksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTrucksMutation, { data, loading, error }] = useImportTrucksMutation({
 *   variables: {
 *      csvFile: // value for 'csvFile'
 *   },
 * });
 */
export function useImportTrucksMutation(baseOptions?: Apollo.MutationHookOptions<ImportTrucksMutation, ImportTrucksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTrucksMutation, ImportTrucksMutationVariables>(ImportTrucksDocument, options);
      }
export type ImportTrucksMutationHookResult = ReturnType<typeof useImportTrucksMutation>;
export type ImportTrucksMutationResult = Apollo.MutationResult<ImportTrucksMutation>;
export type ImportTrucksMutationOptions = Apollo.BaseMutationOptions<ImportTrucksMutation, ImportTrucksMutationVariables>;
export const PasswordResetLinkDocument = gql`
    mutation passwordResetLink($email: String!) {
  passwordResetLink(email: $email) {
    ok
    message
  }
}
    `;
export type PasswordResetLinkMutationFn = Apollo.MutationFunction<PasswordResetLinkMutation, PasswordResetLinkMutationVariables>;

/**
 * __usePasswordResetLinkMutation__
 *
 * To run a mutation, you first call `usePasswordResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetLinkMutation, { data, loading, error }] = usePasswordResetLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePasswordResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetLinkMutation, PasswordResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetLinkMutation, PasswordResetLinkMutationVariables>(PasswordResetLinkDocument, options);
      }
export type PasswordResetLinkMutationHookResult = ReturnType<typeof usePasswordResetLinkMutation>;
export type PasswordResetLinkMutationResult = Apollo.MutationResult<PasswordResetLinkMutation>;
export type PasswordResetLinkMutationOptions = Apollo.BaseMutationOptions<PasswordResetLinkMutation, PasswordResetLinkMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!, $currentPassword: String!, $newPassword: String!) {
  resetPassword(input: {email: $email, currentPassword: $currentPassword, newPassword: $newPassword}) {
    ok
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendDriverTextDocument = gql`
    mutation sendDriverText($mobileNumber: String, $text: String!) {
  textDriver(mobileNumber: $mobileNumber, text: $text) {
    message
    status
  }
}
    `;
export type SendDriverTextMutationFn = Apollo.MutationFunction<SendDriverTextMutation, SendDriverTextMutationVariables>;

/**
 * __useSendDriverTextMutation__
 *
 * To run a mutation, you first call `useSendDriverTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDriverTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDriverTextMutation, { data, loading, error }] = useSendDriverTextMutation({
 *   variables: {
 *      mobileNumber: // value for 'mobileNumber'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendDriverTextMutation(baseOptions?: Apollo.MutationHookOptions<SendDriverTextMutation, SendDriverTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDriverTextMutation, SendDriverTextMutationVariables>(SendDriverTextDocument, options);
      }
export type SendDriverTextMutationHookResult = ReturnType<typeof useSendDriverTextMutation>;
export type SendDriverTextMutationResult = Apollo.MutationResult<SendDriverTextMutation>;
export type SendDriverTextMutationOptions = Apollo.BaseMutationOptions<SendDriverTextMutation, SendDriverTextMutationVariables>;
export const SubmitBidDocument = gql`
    mutation submitBid($lroId: String!, $assetList: [AssetList]!, $bidPrice: Float!) {
  submitBid(bidPrice: $bidPrice, assetList: $assetList, lroId: $lroId) {
    status
    message
  }
}
    `;
export type SubmitBidMutationFn = Apollo.MutationFunction<SubmitBidMutation, SubmitBidMutationVariables>;

/**
 * __useSubmitBidMutation__
 *
 * To run a mutation, you first call `useSubmitBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBidMutation, { data, loading, error }] = useSubmitBidMutation({
 *   variables: {
 *      lroId: // value for 'lroId'
 *      assetList: // value for 'assetList'
 *      bidPrice: // value for 'bidPrice'
 *   },
 * });
 */
export function useSubmitBidMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBidMutation, SubmitBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBidMutation, SubmitBidMutationVariables>(SubmitBidDocument, options);
      }
export type SubmitBidMutationHookResult = ReturnType<typeof useSubmitBidMutation>;
export type SubmitBidMutationResult = Apollo.MutationResult<SubmitBidMutation>;
export type SubmitBidMutationOptions = Apollo.BaseMutationOptions<SubmitBidMutation, SubmitBidMutationVariables>;
export const UpdateBankDetailsDocument = gql`
    mutation updateBankDetails($bankName: String, $accountName: String, $accountNumber: String!, $accountType: String, $bankCode: String, $branchName: String, $swiftCode: String, $bankAddress: String, $beneficiaryName: String, $beneficiaryAddress: String) {
  updateAccount(input: {bankName: $bankName, accountName: $accountName, accountNumber: $accountNumber, accountType: $accountType, bankCode: $bankCode, branchName: $branchName, swiftCode: $swiftCode, bankAddress: $bankAddress, beneficiaryName: $beneficiaryName, beneficiaryAddress: $beneficiaryAddress}) {
    account {
      id
    }
    ok
    message
  }
}
    `;
export type UpdateBankDetailsMutationFn = Apollo.MutationFunction<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>;

/**
 * __useUpdateBankDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBankDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankDetailsMutation, { data, loading, error }] = useUpdateBankDetailsMutation({
 *   variables: {
 *      bankName: // value for 'bankName'
 *      accountName: // value for 'accountName'
 *      accountNumber: // value for 'accountNumber'
 *      accountType: // value for 'accountType'
 *      bankCode: // value for 'bankCode'
 *      branchName: // value for 'branchName'
 *      swiftCode: // value for 'swiftCode'
 *      bankAddress: // value for 'bankAddress'
 *      beneficiaryName: // value for 'beneficiaryName'
 *      beneficiaryAddress: // value for 'beneficiaryAddress'
 *   },
 * });
 */
export function useUpdateBankDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>(UpdateBankDetailsDocument, options);
      }
export type UpdateBankDetailsMutationHookResult = ReturnType<typeof useUpdateBankDetailsMutation>;
export type UpdateBankDetailsMutationResult = Apollo.MutationResult<UpdateBankDetailsMutation>;
export type UpdateBankDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>;
export const UpdateAvatarDocument = gql`
    mutation updateAvatar($avatar: Upload) {
  updateAvatar(input: {avatar: $avatar}) {
    ok
    message
  }
}
    `;
export type UpdateAvatarMutationFn = Apollo.MutationFunction<UpdateAvatarMutation, UpdateAvatarMutationVariables>;

/**
 * __useUpdateAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarMutation, { data, loading, error }] = useUpdateAvatarMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUpdateAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvatarMutation, UpdateAvatarMutationVariables>(UpdateAvatarDocument, options);
      }
export type UpdateAvatarMutationHookResult = ReturnType<typeof useUpdateAvatarMutation>;
export type UpdateAvatarMutationResult = Apollo.MutationResult<UpdateAvatarMutation>;
export type UpdateAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateAvatarMutation, UpdateAvatarMutationVariables>;
export const UpdateCompanyDetailsDocument = gql`
    mutation updateCompanyDetails($tradingName: String, $enterpriseType: String, $postalAddress: String, $physicalAddress: String, $registrationNumber: String, $dateEstablished: DateTime, $numberOfDirectors: Int, $directorDetails: [DirectorDetailsInput], $clientMutationId: String) {
  updateCompanyDetails(input: {tradingName: $tradingName, enterpriseType: $enterpriseType, postalAddress: $postalAddress, physicalAddress: $physicalAddress, registrationNumber: $registrationNumber, dateEstablished: $dateEstablished, numberOfDirectors: $numberOfDirectors, directorDetails: $directorDetails, clientMutationId: $clientMutationId}) {
    companyDetail {
      id
    }
    ok
    message
  }
}
    `;
export type UpdateCompanyDetailsMutationFn = Apollo.MutationFunction<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>;

/**
 * __useUpdateCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDetailsMutation, { data, loading, error }] = useUpdateCompanyDetailsMutation({
 *   variables: {
 *      tradingName: // value for 'tradingName'
 *      enterpriseType: // value for 'enterpriseType'
 *      postalAddress: // value for 'postalAddress'
 *      physicalAddress: // value for 'physicalAddress'
 *      registrationNumber: // value for 'registrationNumber'
 *      dateEstablished: // value for 'dateEstablished'
 *      numberOfDirectors: // value for 'numberOfDirectors'
 *      directorDetails: // value for 'directorDetails'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateCompanyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>(UpdateCompanyDetailsDocument, options);
      }
export type UpdateCompanyDetailsMutationHookResult = ReturnType<typeof useUpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationResult = Apollo.MutationResult<UpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDetailsMutation, UpdateCompanyDetailsMutationVariables>;
export const UpdateContactDetailsDocument = gql`
    mutation updateContactDetails($operationsContactName: String, $operationsTelNumber: String, $mobileNumber: String, $operationsEmail: String, $adminContactName: String, $adminTelNumber: String, $adminEmail: String) {
  updateContact(input: {operationsContactName: $operationsContactName, operationsTelNumber: $operationsTelNumber, mobileNumber: $mobileNumber, operationsEmail: $operationsEmail, adminContactName: $adminContactName, adminTelNumber: $adminTelNumber, adminEmail: $adminEmail}) {
    ok
    message
  }
}
    `;
export type UpdateContactDetailsMutationFn = Apollo.MutationFunction<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>;

/**
 * __useUpdateContactDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateContactDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetailsMutation, { data, loading, error }] = useUpdateContactDetailsMutation({
 *   variables: {
 *      operationsContactName: // value for 'operationsContactName'
 *      operationsTelNumber: // value for 'operationsTelNumber'
 *      mobileNumber: // value for 'mobileNumber'
 *      operationsEmail: // value for 'operationsEmail'
 *      adminContactName: // value for 'adminContactName'
 *      adminTelNumber: // value for 'adminTelNumber'
 *      adminEmail: // value for 'adminEmail'
 *   },
 * });
 */
export function useUpdateContactDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>(UpdateContactDetailsDocument, options);
      }
export type UpdateContactDetailsMutationHookResult = ReturnType<typeof useUpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationResult = Apollo.MutationResult<UpdateContactDetailsMutation>;
export type UpdateContactDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>;
export const UpdateFuelRequestDocument = gql`
    mutation updateFuelRequest($id: Int!, $fuelAmount: Float!, $requestDate: DateTime) {
  updateFuelRequest(input: {id: $id, fuelAmount: $fuelAmount, requestDate: $requestDate}) {
    fuelRequest {
      ...fuelRequestPayload
    }
    ok
    message
  }
}
    ${FuelRequestPayloadFragmentDoc}`;
export type UpdateFuelRequestMutationFn = Apollo.MutationFunction<UpdateFuelRequestMutation, UpdateFuelRequestMutationVariables>;

/**
 * __useUpdateFuelRequestMutation__
 *
 * To run a mutation, you first call `useUpdateFuelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFuelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFuelRequestMutation, { data, loading, error }] = useUpdateFuelRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fuelAmount: // value for 'fuelAmount'
 *      requestDate: // value for 'requestDate'
 *   },
 * });
 */
export function useUpdateFuelRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFuelRequestMutation, UpdateFuelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFuelRequestMutation, UpdateFuelRequestMutationVariables>(UpdateFuelRequestDocument, options);
      }
export type UpdateFuelRequestMutationHookResult = ReturnType<typeof useUpdateFuelRequestMutation>;
export type UpdateFuelRequestMutationResult = Apollo.MutationResult<UpdateFuelRequestMutation>;
export type UpdateFuelRequestMutationOptions = Apollo.BaseMutationOptions<UpdateFuelRequestMutation, UpdateFuelRequestMutationVariables>;
export const UpdateInsuranceDetailsDocument = gql`
    mutation updateInsuranceDetails($broker: String, $brokerContactName: String, $brokerTelNumber: String, $brokerEmail: String, $insuranceCompany: String, $policyNumber: String, $hasComprehensiveGitCover: Boolean, $gitCoverPerLoad: String, $hasPublicLiabilityInsurance: Boolean) {
  updateInsurance(input: {broker: $broker, brokerContactName: $brokerContactName, brokerTelNumber: $brokerTelNumber, brokerEmail: $brokerEmail, insuranceCompany: $insuranceCompany, policyNumber: $policyNumber, hasComprehensiveGitCover: $hasComprehensiveGitCover, gitCoverPerLoad: $gitCoverPerLoad, hasPublicLiabilityInsurance: $hasPublicLiabilityInsurance}) {
    ok
    message
  }
}
    `;
export type UpdateInsuranceDetailsMutationFn = Apollo.MutationFunction<UpdateInsuranceDetailsMutation, UpdateInsuranceDetailsMutationVariables>;

/**
 * __useUpdateInsuranceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateInsuranceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuranceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuranceDetailsMutation, { data, loading, error }] = useUpdateInsuranceDetailsMutation({
 *   variables: {
 *      broker: // value for 'broker'
 *      brokerContactName: // value for 'brokerContactName'
 *      brokerTelNumber: // value for 'brokerTelNumber'
 *      brokerEmail: // value for 'brokerEmail'
 *      insuranceCompany: // value for 'insuranceCompany'
 *      policyNumber: // value for 'policyNumber'
 *      hasComprehensiveGitCover: // value for 'hasComprehensiveGitCover'
 *      gitCoverPerLoad: // value for 'gitCoverPerLoad'
 *      hasPublicLiabilityInsurance: // value for 'hasPublicLiabilityInsurance'
 *   },
 * });
 */
export function useUpdateInsuranceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuranceDetailsMutation, UpdateInsuranceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuranceDetailsMutation, UpdateInsuranceDetailsMutationVariables>(UpdateInsuranceDetailsDocument, options);
      }
export type UpdateInsuranceDetailsMutationHookResult = ReturnType<typeof useUpdateInsuranceDetailsMutation>;
export type UpdateInsuranceDetailsMutationResult = Apollo.MutationResult<UpdateInsuranceDetailsMutation>;
export type UpdateInsuranceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateInsuranceDetailsMutation, UpdateInsuranceDetailsMutationVariables>;
export const UpdatePersonalInfoDocument = gql`
    mutation updatePersonalInfo($firstName: String, $lastName: String, $idNumber: String, $vettingConsent: Boolean) {
  updateProfile(input: {firstName: $firstName, lastName: $lastName, idNumber: $idNumber, vettingConsent: $vettingConsent}) {
    profile {
      id
    }
    ok
    message
  }
}
    `;
export type UpdatePersonalInfoMutationFn = Apollo.MutationFunction<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;

/**
 * __useUpdatePersonalInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalInfoMutation, { data, loading, error }] = useUpdatePersonalInfoMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      idNumber: // value for 'idNumber'
 *      vettingConsent: // value for 'vettingConsent'
 *   },
 * });
 */
export function useUpdatePersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>(UpdatePersonalInfoDocument, options);
      }
export type UpdatePersonalInfoMutationHookResult = ReturnType<typeof useUpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationResult = Apollo.MutationResult<UpdatePersonalInfoMutation>;
export type UpdatePersonalInfoMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalInfoMutation, UpdatePersonalInfoMutationVariables>;
export const UploadAvatarDocument = gql`
    mutation uploadAvatar($avatar: Upload!) {
  uploadAvatar(input: {avatar: $avatar}) {
    ok
    message
  }
}
    `;
export type UploadAvatarMutationFn = Apollo.MutationFunction<UploadAvatarMutation, UploadAvatarMutationVariables>;

/**
 * __useUploadAvatarMutation__
 *
 * To run a mutation, you first call `useUploadAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAvatarMutation, { data, loading, error }] = useUploadAvatarMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUploadAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UploadAvatarMutation, UploadAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAvatarMutation, UploadAvatarMutationVariables>(UploadAvatarDocument, options);
      }
export type UploadAvatarMutationHookResult = ReturnType<typeof useUploadAvatarMutation>;
export type UploadAvatarMutationResult = Apollo.MutationResult<UploadAvatarMutation>;
export type UploadAvatarMutationOptions = Apollo.BaseMutationOptions<UploadAvatarMutation, UploadAvatarMutationVariables>;
export const GetAccountDetailsDocument = gql`
    query getAccountDetails {
  account {
    bankName
    accountName
    accountNumber
    accountType
    bankCode
    branchName
    swiftCode
    bankAddress
    beneficiaryName
    beneficiaryAddress
    currency
  }
}
    `;

/**
 * __useGetAccountDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccountDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
      }
export function useGetAccountDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>(GetAccountDetailsDocument, options);
        }
export type GetAccountDetailsQueryHookResult = ReturnType<typeof useGetAccountDetailsQuery>;
export type GetAccountDetailsLazyQueryHookResult = ReturnType<typeof useGetAccountDetailsLazyQuery>;
export type GetAccountDetailsQueryResult = Apollo.QueryResult<GetAccountDetailsQuery, GetAccountDetailsQueryVariables>;
export const GetActiveJobDetailsDocument = gql`
    query getActiveJobDetails($moveId: Int!) {
  move(moveId: $moveId) {
    ...activeJobDetails
  }
}
    ${ActiveJobDetailsFragmentDoc}`;

/**
 * __useGetActiveJobDetailsQuery__
 *
 * To run a query within a React component, call `useGetActiveJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveJobDetailsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetActiveJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveJobDetailsQuery, GetActiveJobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveJobDetailsQuery, GetActiveJobDetailsQueryVariables>(GetActiveJobDetailsDocument, options);
      }
export function useGetActiveJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveJobDetailsQuery, GetActiveJobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveJobDetailsQuery, GetActiveJobDetailsQueryVariables>(GetActiveJobDetailsDocument, options);
        }
export type GetActiveJobDetailsQueryHookResult = ReturnType<typeof useGetActiveJobDetailsQuery>;
export type GetActiveJobDetailsLazyQueryHookResult = ReturnType<typeof useGetActiveJobDetailsLazyQuery>;
export type GetActiveJobDetailsQueryResult = Apollo.QueryResult<GetActiveJobDetailsQuery, GetActiveJobDetailsQueryVariables>;
export const GetAuthKeyDocument = gql`
    query getAuthKey($app: AppEnum) {
  getAuthKey(app: $app) {
    AccessToken
    RefreshToken
    ExpiresIn
  }
}
    `;

/**
 * __useGetAuthKeyQuery__
 *
 * To run a query within a React component, call `useGetAuthKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthKeyQuery({
 *   variables: {
 *      app: // value for 'app'
 *   },
 * });
 */
export function useGetAuthKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthKeyQuery, GetAuthKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthKeyQuery, GetAuthKeyQueryVariables>(GetAuthKeyDocument, options);
      }
export function useGetAuthKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthKeyQuery, GetAuthKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthKeyQuery, GetAuthKeyQueryVariables>(GetAuthKeyDocument, options);
        }
export type GetAuthKeyQueryHookResult = ReturnType<typeof useGetAuthKeyQuery>;
export type GetAuthKeyLazyQueryHookResult = ReturnType<typeof useGetAuthKeyLazyQuery>;
export type GetAuthKeyQueryResult = Apollo.QueryResult<GetAuthKeyQuery, GetAuthKeyQueryVariables>;
export const GetAvailableDriversDocument = gql`
    query getAvailableDrivers {
  drivers {
    edges {
      node {
        driverId
        driverName
        driverIdNumber
        name
        countryCode
        driverPhoneNumber
        transporterId
        transporter
        active
      }
    }
  }
}
    `;

/**
 * __useGetAvailableDriversQuery__
 *
 * To run a query within a React component, call `useGetAvailableDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableDriversQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableDriversQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>(GetAvailableDriversDocument, options);
      }
export function useGetAvailableDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>(GetAvailableDriversDocument, options);
        }
export type GetAvailableDriversQueryHookResult = ReturnType<typeof useGetAvailableDriversQuery>;
export type GetAvailableDriversLazyQueryHookResult = ReturnType<typeof useGetAvailableDriversLazyQuery>;
export type GetAvailableDriversQueryResult = Apollo.QueryResult<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>;
export const GetAvailableTrailersDocument = gql`
    query getAvailableTrailers {
  trailers {
    edges {
      node {
        trailerRegistration
        trailerType
        trailerId
        transporter
        trailerCapacity
        active
      }
    }
  }
}
    `;

/**
 * __useGetAvailableTrailersQuery__
 *
 * To run a query within a React component, call `useGetAvailableTrailersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTrailersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTrailersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableTrailersQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableTrailersQuery, GetAvailableTrailersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableTrailersQuery, GetAvailableTrailersQueryVariables>(GetAvailableTrailersDocument, options);
      }
export function useGetAvailableTrailersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableTrailersQuery, GetAvailableTrailersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableTrailersQuery, GetAvailableTrailersQueryVariables>(GetAvailableTrailersDocument, options);
        }
export type GetAvailableTrailersQueryHookResult = ReturnType<typeof useGetAvailableTrailersQuery>;
export type GetAvailableTrailersLazyQueryHookResult = ReturnType<typeof useGetAvailableTrailersLazyQuery>;
export type GetAvailableTrailersQueryResult = Apollo.QueryResult<GetAvailableTrailersQuery, GetAvailableTrailersQueryVariables>;
export const GetAvailableTrucksDocument = gql`
    query getAvailableTrucks {
  trucks {
    edges {
      node {
        truckReg
        transporter
        active
        assetId
      }
    }
  }
}
    `;

/**
 * __useGetAvailableTrucksQuery__
 *
 * To run a query within a React component, call `useGetAvailableTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTrucksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableTrucksQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableTrucksQuery, GetAvailableTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableTrucksQuery, GetAvailableTrucksQueryVariables>(GetAvailableTrucksDocument, options);
      }
export function useGetAvailableTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableTrucksQuery, GetAvailableTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableTrucksQuery, GetAvailableTrucksQueryVariables>(GetAvailableTrucksDocument, options);
        }
export type GetAvailableTrucksQueryHookResult = ReturnType<typeof useGetAvailableTrucksQuery>;
export type GetAvailableTrucksLazyQueryHookResult = ReturnType<typeof useGetAvailableTrucksLazyQuery>;
export type GetAvailableTrucksQueryResult = Apollo.QueryResult<GetAvailableTrucksQuery, GetAvailableTrucksQueryVariables>;
export const GetAvatarDocument = gql`
    query getAvatar {
  getAvatar {
    id
    avatar
  }
}
    `;

/**
 * __useGetAvatarQuery__
 *
 * To run a query within a React component, call `useGetAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvatarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvatarQuery(baseOptions?: Apollo.QueryHookOptions<GetAvatarQuery, GetAvatarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvatarQuery, GetAvatarQueryVariables>(GetAvatarDocument, options);
      }
export function useGetAvatarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvatarQuery, GetAvatarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvatarQuery, GetAvatarQueryVariables>(GetAvatarDocument, options);
        }
export type GetAvatarQueryHookResult = ReturnType<typeof useGetAvatarQuery>;
export type GetAvatarLazyQueryHookResult = ReturnType<typeof useGetAvatarLazyQuery>;
export type GetAvatarQueryResult = Apollo.QueryResult<GetAvatarQuery, GetAvatarQueryVariables>;
export const GetBankDetailsDocument = gql`
    query getBankDetails($countryCode: String) {
  banks(countryCode: $countryCode) {
    totalCount
    edges {
      node {
        id
        bankName
        bankCode
        country
        active
        uuid
        clearingCode
      }
    }
  }
}
    `;

/**
 * __useGetBankDetailsQuery__
 *
 * To run a query within a React component, call `useGetBankDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankDetailsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetBankDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetBankDetailsQuery, GetBankDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankDetailsQuery, GetBankDetailsQueryVariables>(GetBankDetailsDocument, options);
      }
export function useGetBankDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankDetailsQuery, GetBankDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankDetailsQuery, GetBankDetailsQueryVariables>(GetBankDetailsDocument, options);
        }
export type GetBankDetailsQueryHookResult = ReturnType<typeof useGetBankDetailsQuery>;
export type GetBankDetailsLazyQueryHookResult = ReturnType<typeof useGetBankDetailsLazyQuery>;
export type GetBankDetailsQueryResult = Apollo.QueryResult<GetBankDetailsQuery, GetBankDetailsQueryVariables>;
export const GetCompanyDetailsDocument = gql`
    query getCompanyDetails {
  companyDetails {
    id
    tradingName
    enterpriseType
    postalAddress
    physicalAddress
    registrationNumber
    dateEstablished
    numberOfDirectors
    company {
      directors {
        edges {
          node {
            directorName
            directorNumber
            directorResidentialAddress
            directorTelNumber
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
      }
export function useGetCompanyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>(GetCompanyDetailsDocument, options);
        }
export type GetCompanyDetailsQueryHookResult = ReturnType<typeof useGetCompanyDetailsQuery>;
export type GetCompanyDetailsLazyQueryHookResult = ReturnType<typeof useGetCompanyDetailsLazyQuery>;
export type GetCompanyDetailsQueryResult = Apollo.QueryResult<GetCompanyDetailsQuery, GetCompanyDetailsQueryVariables>;
export const GetCompletedJobDetailsDocument = gql`
    query getCompletedJobDetails($moveId: Int!) {
  move(moveId: $moveId) {
    ...completedJobDetails
  }
}
    ${CompletedJobDetailsFragmentDoc}`;

/**
 * __useGetCompletedJobDetailsQuery__
 *
 * To run a query within a React component, call `useGetCompletedJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedJobDetailsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetCompletedJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedJobDetailsQuery, GetCompletedJobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedJobDetailsQuery, GetCompletedJobDetailsQueryVariables>(GetCompletedJobDetailsDocument, options);
      }
export function useGetCompletedJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedJobDetailsQuery, GetCompletedJobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedJobDetailsQuery, GetCompletedJobDetailsQueryVariables>(GetCompletedJobDetailsDocument, options);
        }
export type GetCompletedJobDetailsQueryHookResult = ReturnType<typeof useGetCompletedJobDetailsQuery>;
export type GetCompletedJobDetailsLazyQueryHookResult = ReturnType<typeof useGetCompletedJobDetailsLazyQuery>;
export type GetCompletedJobDetailsQueryResult = Apollo.QueryResult<GetCompletedJobDetailsQuery, GetCompletedJobDetailsQueryVariables>;
export const GetConfirmedJobDetailsDocument = gql`
    query getConfirmedJobDetails($moveId: Int!) {
  job(moveId: $moveId) {
    ...confirmedJobDetails
  }
}
    ${ConfirmedJobDetailsFragmentDoc}`;

/**
 * __useGetConfirmedJobDetailsQuery__
 *
 * To run a query within a React component, call `useGetConfirmedJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfirmedJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfirmedJobDetailsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetConfirmedJobDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetConfirmedJobDetailsQuery, GetConfirmedJobDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfirmedJobDetailsQuery, GetConfirmedJobDetailsQueryVariables>(GetConfirmedJobDetailsDocument, options);
      }
export function useGetConfirmedJobDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfirmedJobDetailsQuery, GetConfirmedJobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfirmedJobDetailsQuery, GetConfirmedJobDetailsQueryVariables>(GetConfirmedJobDetailsDocument, options);
        }
export type GetConfirmedJobDetailsQueryHookResult = ReturnType<typeof useGetConfirmedJobDetailsQuery>;
export type GetConfirmedJobDetailsLazyQueryHookResult = ReturnType<typeof useGetConfirmedJobDetailsLazyQuery>;
export type GetConfirmedJobDetailsQueryResult = Apollo.QueryResult<GetConfirmedJobDetailsQuery, GetConfirmedJobDetailsQueryVariables>;
export const GetContactDetailsDocument = gql`
    query getContactDetails {
  contact {
    id
    operationsContactName
    operationsTelNumber
    mobileNumber
    operationsEmail
    adminContactName
    adminTelNumber
    adminEmail
  }
}
    `;

/**
 * __useGetContactDetailsQuery__
 *
 * To run a query within a React component, call `useGetContactDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactDetailsQuery, GetContactDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactDetailsQuery, GetContactDetailsQueryVariables>(GetContactDetailsDocument, options);
      }
export function useGetContactDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactDetailsQuery, GetContactDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactDetailsQuery, GetContactDetailsQueryVariables>(GetContactDetailsDocument, options);
        }
export type GetContactDetailsQueryHookResult = ReturnType<typeof useGetContactDetailsQuery>;
export type GetContactDetailsLazyQueryHookResult = ReturnType<typeof useGetContactDetailsLazyQuery>;
export type GetContactDetailsQueryResult = Apollo.QueryResult<GetContactDetailsQuery, GetContactDetailsQueryVariables>;
export const GetFuelRequestsDocument = gql`
    query getFuelRequests($moveId: Int, $transporterId: Int) {
  fuelRequests(woId: $moveId, transporterId: $transporterId) {
    edges {
      node {
        amountFuelled
        fuelRequestAmount
        fuelStation
        fuelStationId
        fuelType
        lroId
        moveId
        truckReg
        transporterId
        approvalState
        fuelreqtra
      }
    }
  }
}
    `;

/**
 * __useGetFuelRequestsQuery__
 *
 * To run a query within a React component, call `useGetFuelRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelRequestsQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *      transporterId: // value for 'transporterId'
 *   },
 * });
 */
export function useGetFuelRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetFuelRequestsQuery, GetFuelRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuelRequestsQuery, GetFuelRequestsQueryVariables>(GetFuelRequestsDocument, options);
      }
export function useGetFuelRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuelRequestsQuery, GetFuelRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuelRequestsQuery, GetFuelRequestsQueryVariables>(GetFuelRequestsDocument, options);
        }
export type GetFuelRequestsQueryHookResult = ReturnType<typeof useGetFuelRequestsQuery>;
export type GetFuelRequestsLazyQueryHookResult = ReturnType<typeof useGetFuelRequestsLazyQuery>;
export type GetFuelRequestsQueryResult = Apollo.QueryResult<GetFuelRequestsQuery, GetFuelRequestsQueryVariables>;
export const GetFuelLimitDocument = gql`
    query getFuelLimit($moveId: Int) {
  maxFuelLimit(moveId: $moveId) {
    waFuelOptions
    maxFuelAmount
  }
}
    `;

/**
 * __useGetFuelLimitQuery__
 *
 * To run a query within a React component, call `useGetFuelLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelLimitQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useGetFuelLimitQuery(baseOptions?: Apollo.QueryHookOptions<GetFuelLimitQuery, GetFuelLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuelLimitQuery, GetFuelLimitQueryVariables>(GetFuelLimitDocument, options);
      }
export function useGetFuelLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuelLimitQuery, GetFuelLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuelLimitQuery, GetFuelLimitQueryVariables>(GetFuelLimitDocument, options);
        }
export type GetFuelLimitQueryHookResult = ReturnType<typeof useGetFuelLimitQuery>;
export type GetFuelLimitLazyQueryHookResult = ReturnType<typeof useGetFuelLimitLazyQuery>;
export type GetFuelLimitQueryResult = Apollo.QueryResult<GetFuelLimitQuery, GetFuelLimitQueryVariables>;
export const GetFuelStationListDocument = gql`
    query getFuelStationList($moveId: Int!, $after: String, $first: Int) {
  fuelStations(moveId: $moveId, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...fuelStationDetails
      }
    }
  }
}
    ${FuelStationDetailsFragmentDoc}`;

/**
 * __useGetFuelStationListQuery__
 *
 * To run a query within a React component, call `useGetFuelStationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFuelStationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFuelStationListQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetFuelStationListQuery(baseOptions: Apollo.QueryHookOptions<GetFuelStationListQuery, GetFuelStationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFuelStationListQuery, GetFuelStationListQueryVariables>(GetFuelStationListDocument, options);
      }
export function useGetFuelStationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFuelStationListQuery, GetFuelStationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFuelStationListQuery, GetFuelStationListQueryVariables>(GetFuelStationListDocument, options);
        }
export type GetFuelStationListQueryHookResult = ReturnType<typeof useGetFuelStationListQuery>;
export type GetFuelStationListLazyQueryHookResult = ReturnType<typeof useGetFuelStationListLazyQuery>;
export type GetFuelStationListQueryResult = Apollo.QueryResult<GetFuelStationListQuery, GetFuelStationListQueryVariables>;
export const GetInsuranceDetailsDocument = gql`
    query getInsuranceDetails {
  insurance {
    id
    broker
    brokerContactName
    brokerTelNumber
    brokerEmail
    insuranceCompany
    policyNumber
    hasComprehensiveGitCover
    gitCoverPerLoad
    hasPublicLiabilityInsurance
  }
}
    `;

/**
 * __useGetInsuranceDetailsQuery__
 *
 * To run a query within a React component, call `useGetInsuranceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsuranceDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetInsuranceDetailsQuery, GetInsuranceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceDetailsQuery, GetInsuranceDetailsQueryVariables>(GetInsuranceDetailsDocument, options);
      }
export function useGetInsuranceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceDetailsQuery, GetInsuranceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceDetailsQuery, GetInsuranceDetailsQueryVariables>(GetInsuranceDetailsDocument, options);
        }
export type GetInsuranceDetailsQueryHookResult = ReturnType<typeof useGetInsuranceDetailsQuery>;
export type GetInsuranceDetailsLazyQueryHookResult = ReturnType<typeof useGetInsuranceDetailsLazyQuery>;
export type GetInsuranceDetailsQueryResult = Apollo.QueryResult<GetInsuranceDetailsQuery, GetInsuranceDetailsQueryVariables>;
export const GetMoveListDocument = gql`
    query getMoveList($jobCategory: JobCategory!, $searchStr: String, $cargoType: CargoType, $after: String, $first: Int = 10, $moveType: MoveType) {
  myjobList(jobCategory: $jobCategory, moveType: $moveType, searchStr: $searchStr, cargoType: $cargoType, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...moveCardDetails
      }
    }
  }
}
    ${MoveCardDetailsFragmentDoc}`;

/**
 * __useGetMoveListQuery__
 *
 * To run a query within a React component, call `useGetMoveListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoveListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoveListQuery({
 *   variables: {
 *      jobCategory: // value for 'jobCategory'
 *      searchStr: // value for 'searchStr'
 *      cargoType: // value for 'cargoType'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      moveType: // value for 'moveType'
 *   },
 * });
 */
export function useGetMoveListQuery(baseOptions: Apollo.QueryHookOptions<GetMoveListQuery, GetMoveListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoveListQuery, GetMoveListQueryVariables>(GetMoveListDocument, options);
      }
export function useGetMoveListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoveListQuery, GetMoveListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoveListQuery, GetMoveListQueryVariables>(GetMoveListDocument, options);
        }
export type GetMoveListQueryHookResult = ReturnType<typeof useGetMoveListQuery>;
export type GetMoveListLazyQueryHookResult = ReturnType<typeof useGetMoveListLazyQuery>;
export type GetMoveListQueryResult = Apollo.QueryResult<GetMoveListQuery, GetMoveListQueryVariables>;
export const GetPersonalDetailsDocument = gql`
    query getPersonalDetails {
  profile {
    firstName
    lastName
    idNumber
    id
    vettingConsent
  }
}
    `;

/**
 * __useGetPersonalDetailsQuery__
 *
 * To run a query within a React component, call `useGetPersonalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>(GetPersonalDetailsDocument, options);
      }
export function useGetPersonalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>(GetPersonalDetailsDocument, options);
        }
export type GetPersonalDetailsQueryHookResult = ReturnType<typeof useGetPersonalDetailsQuery>;
export type GetPersonalDetailsLazyQueryHookResult = ReturnType<typeof useGetPersonalDetailsLazyQuery>;
export type GetPersonalDetailsQueryResult = Apollo.QueryResult<GetPersonalDetailsQuery, GetPersonalDetailsQueryVariables>;
export const GetTrackingRecordsDocument = gql`
    query getTrackingRecords($truckId: Int, $first: Int, $last: Int, $after: String, $before: String) {
  trackingRecords(truckId: $truckId, first: $first, last: $last, after: $after, before: $before) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        id
        capturedAt
        geoLocation {
          latitude
          longitude
        }
        locationName
        truckReg
        moveId
        updatedBy
        source
      }
    }
  }
}
    `;

/**
 * __useGetTrackingRecordsQuery__
 *
 * To run a query within a React component, call `useGetTrackingRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackingRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackingRecordsQuery({
 *   variables: {
 *      truckId: // value for 'truckId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetTrackingRecordsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrackingRecordsQuery, GetTrackingRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackingRecordsQuery, GetTrackingRecordsQueryVariables>(GetTrackingRecordsDocument, options);
      }
export function useGetTrackingRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackingRecordsQuery, GetTrackingRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackingRecordsQuery, GetTrackingRecordsQueryVariables>(GetTrackingRecordsDocument, options);
        }
export type GetTrackingRecordsQueryHookResult = ReturnType<typeof useGetTrackingRecordsQuery>;
export type GetTrackingRecordsLazyQueryHookResult = ReturnType<typeof useGetTrackingRecordsLazyQuery>;
export type GetTrackingRecordsQueryResult = Apollo.QueryResult<GetTrackingRecordsQuery, GetTrackingRecordsQueryVariables>;
export const GetTrailerTypesDocument = gql`
    query getTrailerTypes {
  getTrailerTypes
}
    `;

/**
 * __useGetTrailerTypesQuery__
 *
 * To run a query within a React component, call `useGetTrailerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrailerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrailerTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrailerTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTrailerTypesQuery, GetTrailerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrailerTypesQuery, GetTrailerTypesQueryVariables>(GetTrailerTypesDocument, options);
      }
export function useGetTrailerTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrailerTypesQuery, GetTrailerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrailerTypesQuery, GetTrailerTypesQueryVariables>(GetTrailerTypesDocument, options);
        }
export type GetTrailerTypesQueryHookResult = ReturnType<typeof useGetTrailerTypesQuery>;
export type GetTrailerTypesLazyQueryHookResult = ReturnType<typeof useGetTrailerTypesLazyQuery>;
export type GetTrailerTypesQueryResult = Apollo.QueryResult<GetTrailerTypesQuery, GetTrailerTypesQueryVariables>;
export const GetTruckTypesDocument = gql`
    query getTruckTypes {
  getTruckTypes
}
    `;

/**
 * __useGetTruckTypesQuery__
 *
 * To run a query within a React component, call `useGetTruckTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTruckTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTruckTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTruckTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTruckTypesQuery, GetTruckTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTruckTypesQuery, GetTruckTypesQueryVariables>(GetTruckTypesDocument, options);
      }
export function useGetTruckTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTruckTypesQuery, GetTruckTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTruckTypesQuery, GetTruckTypesQueryVariables>(GetTruckTypesDocument, options);
        }
export type GetTruckTypesQueryHookResult = ReturnType<typeof useGetTruckTypesQuery>;
export type GetTruckTypesLazyQueryHookResult = ReturnType<typeof useGetTruckTypesLazyQuery>;
export type GetTruckTypesQueryResult = Apollo.QueryResult<GetTruckTypesQuery, GetTruckTypesQueryVariables>;
export const GetUploadedDocumentsDocument = gql`
    query getUploadedDocuments {
  document {
    id
    directorIdentification
    certificateOfIncorporation
    kraPin
    tin
    kraTcc
    proofOfDirectorship
    carriersLiability
    carriersLiabilityExpiry
    carrierResolution
    gitCoverConfirmation
    gitCoverExpiry
    insurancePolicies
    beeCertificate
    bankLetter
    isVatRegistered
    vatRegistrationNumber
    vatCertificate
    registrationCertificate
    taxClearanceCertificate
    companyLetterhead
    directorsIds
    letterOfGoodStanding
    vehicleRegistrationDocuments
    hasQualityManagementCert
    qualityManagementCertificate
    directorKraPin
    goodsInTransitCertificate
    signedLoriContract
  }
}
    `;

/**
 * __useGetUploadedDocumentsQuery__
 *
 * To run a query within a React component, call `useGetUploadedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUploadedDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetUploadedDocumentsQuery, GetUploadedDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedDocumentsQuery, GetUploadedDocumentsQueryVariables>(GetUploadedDocumentsDocument, options);
      }
export function useGetUploadedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedDocumentsQuery, GetUploadedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedDocumentsQuery, GetUploadedDocumentsQueryVariables>(GetUploadedDocumentsDocument, options);
        }
export type GetUploadedDocumentsQueryHookResult = ReturnType<typeof useGetUploadedDocumentsQuery>;
export type GetUploadedDocumentsLazyQueryHookResult = ReturnType<typeof useGetUploadedDocumentsLazyQuery>;
export type GetUploadedDocumentsQueryResult = Apollo.QueryResult<GetUploadedDocumentsQuery, GetUploadedDocumentsQueryVariables>;
export const GetUserInfoDocument = gql`
    query getUserInfo {
  userInfo {
    ...userInfo
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const GetWorkOrderDocument = gql`
    query getWorkOrder($isBid: Boolean, $bidPrice: Float, $jobCategory: JobCategory!, $lroId: String, $moveId: Int, $weight: Float) {
  workOrder(isBid: $isBid, bidPrice: $bidPrice, jobCategory: $jobCategory, lroId: $lroId, moveId: $moveId, weight: $weight) {
    id
    lroId
    cargoType
    commodity
    consignmentMetricTons
    createdOn
    currency
    deadlineToLift
    origin
    driverIdNumber
    etaLoadingPoint
    destination
    trucksNeeded
    totalRequested
    trucksShortlisted
    trucksMatched
    transporterRateType
    transporterPaymentTerms
    maximumFuelAmount
    totalLiters
    lowerBidMargin
    upperBidMargin
    marketRate
    phoneNumber
    trailerType
    trailerTypes
    truckType
    isBid
    bidPrice
    packagingType
    weightToLoad
    weight
    readyToLoad
    lastKnownLocation
    trailerNumber
    truckReg
    moveId
    truckList {
      truckReg
      trailerReg
      driverId
      driverIdNumber
      driverName
      etaLoadingPoint
      createdOnLia
      jobRequestId
    }
  }
}
    `;

/**
 * __useGetWorkOrderQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderQuery({
 *   variables: {
 *      isBid: // value for 'isBid'
 *      bidPrice: // value for 'bidPrice'
 *      jobCategory: // value for 'jobCategory'
 *      lroId: // value for 'lroId'
 *      moveId: // value for 'moveId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useGetWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
      }
export function useGetWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
        }
export type GetWorkOrderQueryHookResult = ReturnType<typeof useGetWorkOrderQuery>;
export type GetWorkOrderLazyQueryHookResult = ReturnType<typeof useGetWorkOrderLazyQuery>;
export type GetWorkOrderQueryResult = Apollo.QueryResult<GetWorkOrderQuery, GetWorkOrderQueryVariables>;
export const GetWorkOrderListDocument = gql`
    query getWorkOrderList($jobCategory: JobCategory!, $searchStr: String, $moveType: MoveType, $cargoType: CargoType, $after: String, $first: Int = 10) {
  jobList(jobCategory: $jobCategory, searchStr: $searchStr, moveType: $moveType, cargoType: $cargoType, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        lroId
        cargoType
        commodity
        consignmentMetricTons
        createdOn
        currency
        deadlineToLift
        origin
        destination
        readyToLoad
        trucksNeeded
        totalRequested
        trucksShortlisted
        trucksMatched
        marketRate
        packagingType
        phoneNumber
        trailerType
        truckType
        isBid
        bidPrice
        weight
        weightToLoad
        destinationCity
        originCity
        transportType
        transporterRateType
        transporterPaymentTerms
      }
    }
  }
}
    `;

/**
 * __useGetWorkOrderListQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderListQuery({
 *   variables: {
 *      jobCategory: // value for 'jobCategory'
 *      searchStr: // value for 'searchStr'
 *      moveType: // value for 'moveType'
 *      cargoType: // value for 'cargoType'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetWorkOrderListQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderListQuery, GetWorkOrderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderListQuery, GetWorkOrderListQueryVariables>(GetWorkOrderListDocument, options);
      }
export function useGetWorkOrderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderListQuery, GetWorkOrderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderListQuery, GetWorkOrderListQueryVariables>(GetWorkOrderListDocument, options);
        }
export type GetWorkOrderListQueryHookResult = ReturnType<typeof useGetWorkOrderListQuery>;
export type GetWorkOrderListLazyQueryHookResult = ReturnType<typeof useGetWorkOrderListLazyQuery>;
export type GetWorkOrderListQueryResult = Apollo.QueryResult<GetWorkOrderListQuery, GetWorkOrderListQueryVariables>;
export const OperationDocument = gql`
    query operation($moveId: Int!) {
  globalOperation(moveId: $moveId) {
    moveId
    truckReg
    truck {
      id
    }
    __typename
  }
}
    `;

/**
 * __useOperationQuery__
 *
 * To run a query within a React component, call `useOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOperationQuery({
 *   variables: {
 *      moveId: // value for 'moveId'
 *   },
 * });
 */
export function useOperationQuery(baseOptions: Apollo.QueryHookOptions<OperationQuery, OperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OperationQuery, OperationQueryVariables>(OperationDocument, options);
      }
export function useOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OperationQuery, OperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OperationQuery, OperationQueryVariables>(OperationDocument, options);
        }
export type OperationQueryHookResult = ReturnType<typeof useOperationQuery>;
export type OperationLazyQueryHookResult = ReturnType<typeof useOperationLazyQuery>;
export type OperationQueryResult = Apollo.QueryResult<OperationQuery, OperationQueryVariables>;